
<template>
  <vs-row>
    <div class="mt-5 w-full">
      <form-wizard
        class="ml-1 mt-2"
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Add Card"
        @on-complete="addCard"
        ref="wiz"
      >
        <template slot="next">
          <vs-button class="ml-5 px-6 wizardBtnPad">Next</vs-button>
        </template>
        <template slot="prev">
          <vs-button class="ml-5 px-6 wizardBtnPad">Back</vs-button>
        </template>
        <template slot="finish">
          <vs-button class="ml-5 px-6 wizardBtnPad">Add Card</vs-button>
        </template>
        <tab-content
          title=""
          class="mb-5"
          :before-change="beforeFirstTabChange"
        >
          <vs-row class="tabCard">
            <vs-row>
              <h3 class="p-5">Card Details</h3>
            </vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <div class="dropdown mt-1 w-full" id="dropdown">
                <div class="addCardFont font-semibold ml-5">
                  Issuer<span v-if="errors.issuerName.success" class="sterik">
                    *</span
                  >
                  <span v-if="!errors.issuerName.success"> *</span>
                </div>
                <vs-input
                  :danger="errors.issuerName.success"
                  :danger-text="errors.issuerName.msg"
                  class="w-full p-5 pt-4"
                  @click="handleFilter"
                  v-on-clickaway="closeColorList"
                  v-model="cardDetails.selectedIssuer.name"
                  readonly
                />
                <div class="dropdown-content" v-show="toggleColorList">
                  <div
                    class="colorItemContainer"
                    @click="cardDetails.selectedIssuer = issuer"
                    :key="index"
                    v-for="(issuer, index) in issuersList"
                  >
                    <div
                      class="colorIconStyle"
                      :style="{ 'background-color': issuer.color }"
                    ></div>
                    <span class="colorTextStyle">{{ issuer.name }}</span>
                  </div>
                </div>
              </div>
              <div class="addCardFont font-semibold ml-5">
                Card Name<span v-if="errors.cardName.success" class="sterik">
                  *</span
                >
                <span v-if="!errors.cardName.success"> *</span>
              </div>
              <vs-input
                class="w-full p-5"
                v-model="cardDetails.cardName"
                :danger="errors.cardName.success"
                :danger-text="errors.cardName.msg"
                maxLength="120"
                @input="validateCardName($event)"
              />
              <vs-row>
                <div class="addCardFont font-semibold ml-5 mt-0">Card Type</div>
              </vs-row>
              <vs-row class="mt-2">
                <vs-radio
                  v-model="cardDetails.cardType"
                  vs-name="creditType"
                  vs-value="credit"
                  class="m-5 addCardFont textSize"
                  @change="cardDetails.cardType = 'credit'"
                  >Credit</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.cardType"
                  vs-name="creditType"
                  vs-value="charge"
                  class="m-5 addCardFont textSize"
                  @change="cardDetails.cardType = 'charge'"
                  >Charge</vs-radio
                >
              </vs-row>

              <vs-row class="p-5 m-5 ml-0 mb-2">
                <vs-col vs-lg="10">
                  <div
                    @click="$refs.uploadAddCard.click()"
                    class="uploadLabelWizard"
                  >
                    {{
                      cardDetails.photo
                        ? cardDetails.photo.name
                        : "Upload Card Picture"
                    }}
                  </div>
                  <input
                    type="file"
                    class="hidden"
                    ref="uploadAddCard"
                    multiple
                    @change="showFilePath"
                  />
                </vs-col>

                <vs-col vs-lg="2" class="uploadContainerAddWizard">
                  <div class="btn-addon">
                    <vs-button
                      size="small"
                      color="primary"
                      @click="$refs.uploadAddCard.click()"
                    >
                      <UploadCloudIcon />
                    </vs-button>
                  </div>
                </vs-col>
                <vs-row>
                  <div v-show="errors.photo.success">
                    <div id="errFont" class="dangerColor mt-3">
                      <span>{{ errors.photo.msg }}</span>
                    </div>
                  </div>
                </vs-row>
              </vs-row>
              <vs-row v-if="previewPicture.length > 0">
                <vs-col vs-lg="10">
                  <vs-row>
                    <div
                      :key="index"
                      v-for="(picture, index) in previewPicture"
                      class="ml-4 addCardFont font-semibold mb-3"
                      @click="imageclicked(picture.src)"
                    >
                      <vs-dropdown>
                        <vue-load-image>
                          <img
                            v-if="photoChangeFlag == false"
                            slot="image"
                            :src="
                              cardDetails.photo
                                ? $ApiKeys.BASE_URL + cardDetails.photo
                                : require('@/assets/images/no_preview.jpg')
                            "
                            height="45"
                            width="75"
                          />
                          <img
                            v-bind:class="[
                              picture.defaultImage &&
                              picture.defaultImage == true
                                ? 'defaultImageStyle'
                                : 'ImageStyle',
                            ]"
                            v-if="photoChangeFlag == true"
                            slot="image"
                            :src="picture.src"
                            height="45"
                            width="75"
                          />

                          <img
                            slot="preloader"
                            src="@/assets/images/image-loader.gif"
                            height="45"
                            width="75"
                          />
                          <div slot="error">
                            <img
                              slot="image"
                              :src="require('@/assets/images/no_preview.jpg')"
                              height="45"
                              width="75"
                            />
                          </div>
                        </vue-load-image>

                        <vs-dropdown-menu>
                          <vs-dropdown-item @click="defaultImage(index)">
                            Mark as default
                          </vs-dropdown-item>
                          <!-- <vs-dropdown-item
                            @click="imageclicked(picture)"
                            divider
                          >
                            Zoom
                          </vs-dropdown-item> -->
                          <vs-dropdown-item
                            @click="removeCardImage(picture, index)"
                            divider
                          >
                            Remove
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <div class="addCardFont font-semibold ml-5">Product Change</div>
              <vs-row>
                <vs-col class="px-4 mt-5 pr-5">
                  <select
                    v-if="cardsList.length > 0"
                    v-model="cardDetails.productChange"
                    :class="{
                      'w-full posSelect p-3': true,
                      'mb-2': cardDetails.productChange,
                    }"
                    @change="handleCardFilter"
                  >
                    <option
                      v-for="card in cardsList"
                      :key="card._id"
                      :value="card._id"
                    >
                      {{ card.name }}
                    </option>
                  </select>
                  <select
                    v-else
                    class="w-full posSelect p-3 mb-2"
                    :disabled="true"
                  >
                    <option selected>No Cards Available</option>
                  </select>
                </vs-col>
              </vs-row>
              <div class="addCardFont font-semibold ml-5 mt-4">
                Upgrade Card
              </div>
              <vs-row>
                <vs-col class="px-4 mt-5 pr-5">
                  <select
                    v-if="cardsList.length > 0"
                    v-model="cardDetails.upgradeCard"
                    class="w-full posSelect p-3"
                    @change="handleCardFilter"
                  >
                    <option
                      v-for="card in cardsList"
                      :key="card._id"
                      :value="card._id"
                    >
                      {{ card.name }}
                    </option>
                  </select>
                  <select v-else class="w-full posSelect p-3" :disabled="true">
                    <option selected>No Cards Available</option>
                  </select>
                </vs-col>
              </vs-row>
              <div class="addCardFont font-semibold ml-5 mt-1 pt-2">
                Downgrade Card
              </div>
              <vs-row>
                <vs-col class="px-4 mt-5 pr-5">
                  <select
                    v-if="cardsList.length > 0"
                    v-model="cardDetails.downgradeCard"
                    class="w-full posSelect p-3"
                    @change="handleCardFilter"
                    :disabled="cardsList.length == 0"
                  >
                    <option
                      v-for="card in cardsList"
                      :key="card._id"
                      :value="card._id"
                    >
                      {{ card.name }}
                    </option>
                  </select>
                  <select v-else class="w-full posSelect p-3" :disabled="true">
                    <option selected>No Cards Available</option>
                  </select>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </tab-content>

        <tab-content
          title=""
          class="mb-5"
          :before-change="beforeSecondTabChange"
        >
          <vs-row class="tabCard">
            <vs-row>
              <h3 class="p-5">Annual Fees</h3>
            </vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <div class="addCardFont font-semibold ml-5">
                Annual Fee<span v-if="errors.annualFee.success" class="sterik">
                  *</span
                >
                <span v-if="!errors.annualFee.success"> *</span>
              </div>
              <vs-input
                maxlength="20"
                type="number"
                min="0"
                class="w-full p-5"
                v-model="cardDetails.annualFee"
                :danger="errors.annualFee.success"
                :danger-text="errors.annualFee.msg"
                @input="calculateEffectiveFee"
                @keydown="validateNumeric($event)"
              />
              <!-- <vs-row id="editor"> -->

              <!-- </vs-row> -->
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="inputContainer">
              <div class="addCardFont font-semibold ml-5">
                International Transaction Fee
              </div>
              <vs-row class="mt-2">
                <vs-radio
                  v-model="cardDetails.international_transaction_status"
                  vs-name="type"
                  vs-value="yes"
                  class="m-5"
                  @change="updateInternationalTransaction('yes')"
                  >Yes</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.international_transaction_status"
                  vs-name="type"
                  vs-value="no"
                  class="m-5"
                  @change="updateInternationalTransaction('no')"
                  >No</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.international_transaction_status"
                  vs-name="type"
                  vs-value="NA"
                  class="m-5"
                  @change="updateInternationalTransaction('NA')"
                  >N/A</vs-radio
                >
              </vs-row>
            </vs-col>
            <vs-col
              vs-lg="3"
              vs-sm="12"
              class="inputContainer pt-2 max-height-5-24"
              vs-type="flex"
              vs-justify="center"
            >
              <vs-checkbox
                v-model="cardDetails.five_twenty_four"
                vs-name="rule-type"
                :vs-value="true"
                class="m-2 mt-5"
              />
              <div class="addCardFont font-semibold ml-0 mt-5 pt-6">
                Counts toward Chase 5/24
              </div>
            </vs-col>
            <vs-row>
              <div class="ml-4 mb-1 mt-5 mb-5 font-semibold">
                Add breakdown of Annual Fees to calculate Effective Fees
              </div>
            </vs-row>

            <div v-show="errors.feeCategory.success" class="ml-5 mb-3">
              <div id="errFont" class="dangerColor mt-3">
                <span>{{ errors.feeCategory.msg }}</span>
              </div>
            </div>
            <vs-row
              :key="index"
              v-for="(category, index) in cardDetails.fee_categories"
            >
              <vs-row class="my-2">
                <vs-col vs-lg="6" class="pr-6 pl-5 inputContainer">
                  <div class="addCardFont font-semibold">Credit Title</div>
                  <vs-input
                    maxLength="30"
                    placeholder="e.g Uber Credit"
                    class="w-full py-3"
                    v-model="cardDetails.fee_categories[index].credit_title"
                    :value="index"
                  />
                  <vs-col vs-lg="12">
                    <div class="addCardFont font-semibold pl-2 mt-1">
                      Amount
                    </div>
                    <vs-input
                      maxlength="20"
                      type="number"
                      min="0"
                      class="w-full py-3 inputContainer"
                      v-model="cardDetails.fee_categories[index].amount"
                      @input="calculateEffectiveFee"
                      @keydown="validateNumeric($event)"
                    />
                  </vs-col>
                  <vs-col vs-lg="12">
                    <div class="addCardFont font-semibold pl-2 mt-1">
                      Per Use Amount
                    </div>
                    <vs-input
                      maxlength="20"
                      type="number"
                      min="0"
                      class="w-full py-3 inputContainer"
                      v-model="cardDetails.fee_categories[index].per_use_amount"
                      @input="calculateEffectiveFee"
                      @keydown="validateNumeric($event)"
                    />
                  </vs-col>

                  <vs-col vs-lg="12">
                    <vs-row>
                      <vs-col vs-lg="6">
                        <div class="addCardFont font-semibold">Cutoff Date</div>
                      </vs-col>
                      <vs-col vs-lg="6">
                        <vs-row
                          class="
                            vs-row
                            inputContainer
                            max-height-5-24
                            alignRight
                          "
                          vs-type="flex"
                        >
                          <vs-checkbox
                            @click="setCreditCutoffNA(index)"
                            :checked="
                              cardDetails.fee_categories[index].na_cutoff
                            "
                            vs-name="rule-type"
                          />
                          <div class="text-white">N/A</div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <Datepicker
                      v-model="cardDetails.fee_categories[index].cutoff_date"
                      wrapper-class="py-5 pt-0 pb-0 my-3"
                      calendar-class="posCalendar"
                      input-class="bgColorInput"
                      placeholder="MM/DD/YYYY"
                      format="MM/dd/yyyy"
                      :disabled="cardDetails.fee_categories[index].na_cutoff"
                    />
                  </vs-col>

                  <vs-col vs-lg="12">
                    <div class="addCardFont font-semibold pl-2 mt-1">
                      Expiration Date Type
                    </div>
                    <!-- <vs-input maxlength="20" type="number" min="0" class="w-full py-3 inputContainer" v-model="cardDetails.fee_categories[index].amount" @input="calculateEffectiveFee" @keydown="validateNumeric($event)"/> -->
                    <select
                      v-model="
                        cardDetails.fee_categories[index].expiration_date_type
                      "
                      class="w-full posSelect my-5 px-2"
                    >
                      <option
                        v-for="exp in expiration_date_type_options"
                        :key="exp.value"
                        :value="exp.value"
                      >
                        {{ exp.name }}
                      </option>
                    </select>
                  </vs-col>

                  <vs-row
                    class="mb-5"
                    v-if="
                      cardDetails.fee_categories[index].expiration_date_type !=
                        '' &&
                      cardDetails.fee_categories[index].expiration_date_type !=
                        'custom_date' &&
                      cardDetails.fee_categories[index].expiration_date_type !=
                        'NA' &&
                      cardDetails.fee_categories[index].expiration_date_addition
                    "
                  >
                    <vs-col vs-lg="4">
                      <vs-row>
                        <div class="addCardFont font-semibold">Weeks</div>
                      </vs-row>
                      <vs-row>
                        <vs-input
                          class="w-full pr-5"
                          type="number"
                          min="0"
                          maxlength="20"
                          @keydown="validateNumeric($event)"
                          v-model="
                            cardDetails.fee_categories[index]
                              .expiration_date_addition.weeks
                          "
                        />
                      </vs-row>
                    </vs-col>

                    <vs-col vs-lg="4">
                      <vs-row>
                        <div class="addCardFont font-semibold">Months</div>
                      </vs-row>
                      <vs-row>
                        <vs-input
                          class="w-full"
                          type="number"
                          min="0"
                          maxlength="20"
                          @keydown="validateNumeric($event)"
                          v-model="
                            cardDetails.fee_categories[index]
                              .expiration_date_addition.months
                          "
                        />
                      </vs-row>
                    </vs-col>

                    <vs-col vs-lg="4">
                      <vs-row>
                        <div class="addCardFont font-semibold ml-5">Years</div>
                      </vs-row>
                      <vs-row>
                        <vs-input
                          class="w-full pl-5"
                          type="number"
                          min="0"
                          maxlength="20"
                          @keydown="validateNumeric($event)"
                          v-model="
                            cardDetails.fee_categories[index]
                              .expiration_date_addition.years
                          "
                        />
                      </vs-row>
                    </vs-col>
                  </vs-row>

                  <vs-row
                    class="pb-5"
                    v-if="
                      cardDetails.fee_categories[index].expiration_date_type ==
                      'custom_date'
                    "
                  >
                    <vs-row
                      class="pb-3"
                      :key="date_index"
                      v-for="(custom_date, date_index) in cardDetails
                        .fee_categories[index].custom_dates"
                    >
                      <Datepicker
                        :disabled-dates="
                          cardDetails.fee_categories[index].custom_dates[
                            date_index - 1
                          ] && {
                            to: new Date(
                              new Date(
                                cardDetails.fee_categories[index].custom_dates[
                                  date_index - 1
                                ]
                              ).getTime() +
                                60 * 60 * 24 * 1000
                            ),
                          }
                        "
                        v-model="
                          cardDetails.fee_categories[index].custom_dates[
                            date_index
                          ]
                        "
                        wrapper-class="py-5 pr-5 mt-0 pt-0 pb-0"
                        calendar-class="posCalendar"
                        input-class="bgColorInput"
                        placeholder="MM/DD/YYYY"
                        format="MM/dd/yyyy"
                      />
                      <div
                        class="flex flex-wrap-reverse items-center cursor mt-1"
                        @click="
                          cardDetails.fee_categories[index].custom_dates.splice(
                            date_index,
                            1
                          )
                        "
                      >
                        <MinusSquareIcon size="20" color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove Date
                        </div>
                      </div>
                    </vs-row>

                    <div
                      class="flex flex-wrap-reverse items-center cursor"
                      @click="addCreditCustomDate(index)"
                    >
                      <PlusSquareIcon size="20" color="white" />
                      <h6 class="ml-2 cursor">Add Date</h6>
                    </div>
                  </vs-row>
                </vs-col>
                <vs-col
                  vs-lg="4"
                  class="pr-6 inputContainer pt-6 mt-3 tinymce-dynamic-wrapper"
                >
                  <Editor
                    v-model="cardDetails.fee_categories[index].description"
                    api-key="5nhm4pgf51fpuh0eu4mibhh6y67oxybsqctow1rpfvperrft"
                    :init="{
                      selector: 'textarea',
                      content_style: 'body, body a { color: white }',
                      width: '95%',
                      height: 290,
                      menubar: false,
                      plugins: 'link paste autolink',
                      default_link_target: '_blank',
                      toolbar:
                        'bold italic underline strikethrough | link anchor',
                    }"
                  />
                  <vs-col vs-lg="12" class="mt-2">
                    <vs-button
                      id="buttontext"
                      width="90%"
                      class="items-center cursor ml-4 mt-10"
                      @click="showBonusCategoryModel(index, 'fee')"
                      >Manage BonusCategories</vs-button
                    >
                  </vs-col>
                </vs-col>
                <vs-col vs-lg="2" class="flex">
                  <div
                    class="
                      flex flex-wrap-reverse
                      items-center
                      pl-3
                      fix-category-remove-btn
                      ml-5
                    "
                  >
                    <div
                      class="cursor flex flex-wrap-reverse items-center"
                      @click="removeCategoryItem(index)"
                    >
                      <MinusSquareIcon color="white" />
                      <div class="addCardFont font-semibold ml-3">Remove</div>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
            </vs-row>

            <!-- <modal
              :pointsCategoriesOption="pointsCategoriesOption"
              :showModal="showModal"
              :index="bonusIndex"
              :bonusCategory="cardDetails.fee_categories"
              @close_modal_success="closeModalonSuccess"
              @close_modal_dismiss="closeModalonDismiss"
            ></modal> -->
            <vs-row>
              <div
                class="flex flex-wrap-reverse items-center ml-5 cursor my-6"
                @click="addNewCredit"
              >
                <PlusSquareIcon color="white" />
                <div
                  id="whiteText"
                  class="addCardFont font-semibold ml-3 cursor"
                >
                  Add Credit
                </div>
              </div>
            </vs-row>
            <vs-col vs-lg="8" class="px-3 pr-0">
              <vs-row vs-justify="space-between" class="border-top p-3 pr-0">
                <div id="whiteText">Effective Fee</div>
                <div id="whiteText">
                  {{
                    calculatedFee >= 0
                      ? "$" + calculatedFee
                      : "-$" + calculatedFee * -1
                  }}
                </div>
              </vs-row>
            </vs-col>
          </vs-row>
        </tab-content>

        <tab-content
          title=""
          class="mb-5 tabCard"
          :before-change="beforeThirdTabChange"
        >
          <vs-row>
            <vs-row>
              <h3 class="p-5">Point Details</h3>
            </vs-row>
            <vs-row
              v-if="
                cardDetails.pointsCategories &&
                cardDetails.pointsCategories.length > 0
              "
            >
              <vs-col vs-lg="9" vs-sm="12" vs-xs="12">
                <vs-row>
                  <div>
                    <h6 class="p-3 pl-5 valuation">Valuation</h6>
                  </div>

                  <div>
                    <vs-input
                      v-model="valuation"
                      maxlength="40"
                      type="number"
                      min="0"
                      class="pl-2"
                      placeholder="Enter Valuation"
                      @keydown="validateNumeric($event, true)"
                    />
                  </div>
                  <div>
                    <vs-button
                      class="ml-3"
                      @click="calculatePercentages"
                      :disabled="valuation <= 0"
                      >Calculate</vs-button
                    >
                  </div>
                  <vs-row>
                    <div class="mt-5 ml-3">
                      <vs-row>
                        <!-- <vs-checkbox
                          class="ml-2 mb-3"
                          vs-name="global_dynamic_bonus_category"
                          v-model="cardDetails.dynamic_bonus_category"
                        />
                        <div class="text-white smalltext">
                          Dynamic Bonus Category
                        </div> -->
                        <div
                          class="
                            flex flex-wrap-reverse
                            items-center
                            ml-2
                            mt-1
                            mb-6
                            cursor
                          "
                          @click="addDynamicBonusCategory"
                        >
                          <PlusSquareIcon color="white" />
                          <h6 class="ml-2 mt-1 cursor">
                            Create Dynamic Bonus Category
                          </h6>
                        </div>
                      </vs-row>
                    </div>
                  </vs-row>
                  <vs-row
                    v-if="
                      dynamic_bonus_categoires &&
                      dynamic_bonus_categoires.length > 0
                    "
                  >
                    <vs-row
                      :key="index"
                      v-for="(dynamic, index) in dynamic_bonus_categoires"
                    >
                      <vs-row>
                        <vs-col class="ml-5 mt-1" vs-lg="6">
                          <h6>Dynamic Bonus Category {{ index + 1 }}</h6>
                        </vs-col>
                        <vs-col vs-lg="5">
                          <div
                            class="
                              flex flex-wrap-reverse
                              items-center
                              ml-3
                              mr-5
                              cursor
                            "
                            @click="
                              dynamic_bonus_categoires.splice(index, 1),
                                removeDynamicBonusCategories(index)
                            "
                          >
                            <MinusSquareIcon color="white" />
                            <div class="addCardFont font-semibold ml-2 cursor">
                              Remove
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                      <div class="ml-3">
                        <div class="mt-2 ml-2">Set Category Limit</div>
                        <vs-input
                          type="number"
                          min="0"
                          id="transparent"
                          v-model="dynamic_bonus_categoires[index].limit"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                        />
                      </div>
                    </vs-row>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12">
                <div class="p-3 pt-0 pr-0 pb-8">
                  <vs-row>
                    <div class="addCardFont ml-4 font-semibold cursor">
                      Points Description
                    </div>

                    <Editor
                      v-model="cardDetails.pointsDescription"
                      api-key="5nhm4pgf51fpuh0eu4mibhh6y67oxybsqctow1rpfvperrft"
                      :init="{
                        selector: 'textarea',
                        content_style: 'body, body a { color: white }',
                        width: '90%',
                        menubar: false,
                        plugins: 'link paste autolink',
                        toolbar:
                          'bold italic underline strikethrough | link anchor',
                      }"
                    />
                  </vs-row>
                </div>
              </vs-col>
            </vs-row>
            <vs-row
              class="border-top ml-5 mr-4 pb-1"
              v-if="
                cardDetails.pointsCategories &&
                cardDetails.pointsCategories.length > 0
              "
            >
            </vs-row>
            <vs-row>
              <vs-col vs-lg="12 p-3" vs-sm="12 p-3">
                <vs-row
                  :key="index"
                  v-for="(category, index) in cardDetails.pointsCategories"
                >
                  <!-- <vs-col vs-lg="3" vs-sm="4" vs-xs="12" class="mt-5 px-2">
                   -->
                  <div class="mt-5 px-2">
                    <select
                      v-model="
                        cardDetails.pointsCategories[index].points_category
                      "
                      @change="categorychangeHandler(index)"
                      class="w-full posSelect p-3"
                    >
                      <option
                        v-for="cat in pointsCategoriesOption"
                        :key="cat._id"
                        :value="cat._id"
                      >
                        {{ cat.name }}
                      </option>
                    </select>
                  </div>
                  <!-- </vs-col> -->
                  <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                  <div
                    class="flex flex-wrap-reverse items-center ml-0 cursor my-6"
                  >
                    <vx-tooltip
                      text="Press the button to add a new point category if you did not find it in the list"
                      position="top"
                    >
                      <vs-row>
                        <PlusSquareIcon
                          color="white"
                          @click="showPointCategryModal('single', index, 0)"
                        />
                      </vs-row>
                    </vx-tooltip>
                  </div>
                  <div>
                    <vs-input
                      maxlength="3"
                      type="number"
                      min="0"
                      class="p-5 pl-2"
                      placeholder="Percentage"
                      v-model="cardDetails.pointsCategories[index].percentage"
                      @keydown="validateNumeric($event, true)"
                    />
                  </div>
                  <div>
                    <vs-input-number
                      v-model="cardDetails.pointsCategories[index].multiplier"
                      class="inline-flex m-6 mr-6"
                      min="0"
                    />
                  </div>

                  <div
                    v-if="cardDetails.pointsCategories[index].type == 'single'"
                    class="flex flex-wrap-reverse items-center ml-3 mr-5 cursor"
                    @click="removeSingleitemPointCategory(index)"
                  >
                    <MinusSquareIcon color="white" />
                    <div class="addCardFont font-semibold ml-2 cursor">
                      Remove
                    </div>
                  </div>
                  <div
                    v-if="cardDetails.pointsCategories[index].type == 'group'"
                    class="flex flex-wrap-reverse items-center ml-3 mr-5 cursor"
                    @click="removeGroupItem(index)"
                  >
                    <MinusSquareIcon color="white" />
                    <div class="addCardFont font-semibold ml-2 cursor">
                      Remove
                    </div>
                  </div>

                  <vs-col
                    vs-lg="3 mb-5"
                    vs-sm="3"
                    vs-xs="6 "
                    vs-type="flex"
                    vs-justify="flex-end"
                  >
                    <div>
                      <vs-button
                        id="buttontext"
                        width="90%"
                        class="items-center cursor mt-5"
                        @click="ManageSubcategory(index, 'show')"
                        >Manage Subcategories</vs-button
                      >
                    </div>
                  </vs-col>
                  <vs-row class="ml-0">
                    <vs-col vs-lg="9">
                      <vs-col
                        vs-lg="4"
                        class="mb-3"
                        :key="DynamicindexCat"
                        v-for="(dyn, DynamicindexCat) in cardDetails
                          .pointsCategories[index].dynamic_bonus_category"
                      >
                        <vs-row>
                          <vs-checkbox
                            class="ml-2 mb-3"
                            vs-name="global_dynamic_bonus_category"
                            v-model="
                              cardDetails.pointsCategories[index]
                                .dynamic_bonus_category[DynamicindexCat].isAdded
                            "
                          />
                          <div class="text-white smalltext">
                            Dynamic Bonus Category {{ DynamicindexCat + 1 }}
                          </div>
                        </vs-row>
                        <!-- <div>
                          <label class="container" style="padding-left: 24px"
                            >Dynamic Bonus Category {{ DynamicindexCat + 1 }}
                            <input
                              type="checkbox"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .dynamic_bonus_category[DynamicindexCat]
                                  .isAdded
                              "
                              v-bind:name="
                                'dynamic_bonus_category' +
                                index +
                                DynamicindexCat
                              "
                              value="true"
                              @click="changeIsAdded(index, DynamicindexCat)"
                            />
                            <span
                              class="checkmark"
                              style="border-radius: 2px"
                            ></span>
                          </label>
                        </div> -->
                      </vs-col>
                    </vs-col>
                  </vs-row>
                  <vs-row
                    v-if="cardDetails.pointsCategories[index].type == 'group'"
                  >
                    <vs-row
                      :key="Groupindex"
                      v-for="(Groupcategory, Groupindex) in cardDetails
                        .pointsCategories[index].groupCategories"
                    >
                      <div class="mt-5 px-2">
                        <select
                          v-model="
                            cardDetails.pointsCategories[index].groupCategories[
                              Groupindex
                            ].points_category
                          "
                          class="w-full posSelect p-3"
                        >
                          <option
                            v-for="cat in pointsCategoriesOption"
                            :key="cat._id"
                            :value="cat._id"
                          >
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                      <!-- </vs-col> -->
                      <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-0
                          cursor
                          my-6
                        "
                      >
                        <vx-tooltip
                          text="Press the button to add a new point category if you did not find it in the list"
                          position="top"
                        >
                          <vs-row>
                            <PlusSquareIcon
                              color="white"
                              @click="
                                showPointCategryModal(
                                  'group',
                                  index,
                                  Groupindex
                                )
                              "
                            />
                          </vs-row>
                        </vx-tooltip>
                      </div>
                      <div>
                        <vs-input
                          maxlength="3"
                          type="number"
                          min="0"
                          class="p-5 pl-2"
                          placeholder="Percentage"
                          v-model="
                            cardDetails.pointsCategories[index].groupCategories[
                              Groupindex
                            ].percentage
                          "
                          @keydown="validateNumeric($event, true)"
                        />
                      </div>
                      <div>
                        <vs-input-number
                          v-model="
                            cardDetails.pointsCategories[index].groupCategories[
                              Groupindex
                            ].multiplier
                          "
                          class="inline-flex m-6 mr-6"
                          min="0"
                        />
                      </div>
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-3
                          mr-5
                          cursor
                        "
                        @click="removeGroupPointsCategory(index, Groupindex)"
                      >
                        <MinusSquareIcon color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove
                        </div>
                      </div>
                      <vs-row class="ml-0">
                        <vs-col vs-lg="9">
                          <vs-col
                            vs-lg="4"
                            class="mb-3"
                            :key="Dynamicindex"
                            v-for="(dyn, Dynamicindex) in cardDetails
                              .pointsCategories[index].groupCategories[
                              Groupindex
                            ].dynamic_bonus_category"
                          >
                            <vs-row>
                              <vs-checkbox
                                class="ml-2 mb-3"
                                vs-name="global_dynamic_bonus_category"
                                v-model="
                                  cardDetails.pointsCategories[index]
                                    .groupCategories[Groupindex]
                                    .dynamic_bonus_category[Dynamicindex]
                                    .isAdded
                                "
                              />
                              <div class="text-white smalltext">
                                Dynamic Bonus Category {{ Dynamicindex + 1 }}
                              </div>
                            </vs-row>
                            <!-- <div>
                              <label
                                class="container"
                                style="padding-left: 24px"
                                >Dynamic Bonus Category {{ Dynamicindex + 1 }}
                                <input
                                  type="checkbox"
                                  v-model="
                                    cardDetails.pointsCategories[index]
                                      .groupCategories[Groupindex]
                                      .dynamic_bonus_category[Dynamicindex]
                                      .isAdded
                                  "
                                  v-bind:name="
                                    'dynamic_bonus_category' +
                                    index +
                                    Groupindex +
                                    Dynamicindex
                                  "
                                  value="true"
                                />
                                <span
                                  class="checkmark"
                                  style="border-radius: 2px"
                                ></span>
                              </label>
                            </div> -->
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </vs-row>

                  <vs-row
                    v-if="cardDetails.pointsCategories[index].type == 'group'"
                  >
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-2
                        mt-1
                        mb-6
                        cursor
                      "
                      @click="addPointCategoryGroupCategory(index)"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                    </div>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].points_category != ''
                    "
                  >
                    <!-- <vs-col vs-lg="2" vs-sm="3"> -->
                    <div style="margin-right: 5%">
                      <vs-row>
                        <vs-checkbox
                          class="ml-2 mb-3"
                          v-model="
                            cardDetails.pointsCategories[index]
                              .manage_spend_limit
                          "
                          vs-name="manage_spend_limit"
                        />

                        <div class="text-white smalltext">
                          Manage Spend Limit
                        </div>
                      </vs-row>
                    </div>
                    <!-- </vs-col> -->
                    <!-- <vs-col vs-lg="3" vs-sm="3" style="margin-left: 5%"> -->
                    <!-- <div>
                      <vs-row>
                        <vs-checkbox
                          class="ml-2 mb-3"
                          v-model="
                            cardDetails.pointsCategories[index]
                              .dynamic_bonus_category
                          "
                          vs-name="dynamic_bonus_category"
                        />
                        <div class="text-white smalltext">
                          Dynamic Bonus Category
                        </div>
                      </vs-row>
                    </div> -->
                    <!-- </vs-col> -->
                  </vs-row>

                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit
                    "
                  >
                    <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                        <div class="mt-2 ml-2">Spend Limit</div>

                        <vs-input
                          type="number"
                          id="transparent"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                          v-model="
                            cardDetails.pointsCategories[index]
                              .manage_spend_limit_options.spend_limit
                          "
                          min="0"
                          @keydown="validateNumeric($event)"
                        />
                      </vs-col>

                      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                        <div class="mt-2 ml-2">Points Limit</div>
                        <vs-input
                          type="number"
                          id="transparent"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                          v-model="
                            cardDetails.pointsCategories[index]
                              .manage_spend_limit_options.points_limit
                          "
                          min="0"
                          @keydown="validateNumeric($event)"
                        />
                      </vs-col>
                    </vs-col>
                    <!-- <vs-col vs-lg="5" vs-sm="7" vs-xs="12">
                      <div class="mt-2 ml-2">Spend Limit</div>
                      <vs-input
                        type="number"
                        id="transparent"
                        class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                        v-model="
                          cardDetails.pointsCategories[index]
                            .manage_spend_limit_options.spend_limit
                        "
                        min="0"
                        @keydown="validateNumeric($event)"
                      />
                    </vs-col> -->
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit
                    "
                  >
                    <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                      <vs-row>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12" class="mr-0">
                          <label class="ml-2">Beginning Date </label>
                          <div
                            v-if="
                              cardDetails.pointsCategories[index]
                                .manage_spend_limit_options.date_type !=
                              'calendar_year'
                            "
                          >
                            <Datepicker
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.beginningDate
                              "
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                          <div v-else>
                            <Datepicker
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <label class="ml-2">End Date </label>
                          <div
                            v-if="
                              cardDetails.pointsCategories[index]
                                .manage_spend_limit_options.date_type !=
                              'calendar_year'
                            "
                          >
                            <Datepicker
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.endDate
                              "
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                          <div v-else>
                            <Datepicker
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                    <!-- <vs-col vs-lg="6" vs-sm="8" vs-xs="12">
                      <vs-row>
                        <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mr-4">
                          <label class="ml-2">Beginning Date </label>
                          <Datepicker
                            v-model="
                              cardDetails.pointsCategories[index]
                                .manage_spend_limit_options.beginningDate
                            "
                            wrapper-class="p-5 pl-2 mt-2 pt-0 pb-0 mb-2"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-col>
                        <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                          <label class="ml-2">End Date </label>
                          <Datepicker
                            v-model="
                              cardDetails.pointsCategories[index]
                                .manage_spend_limit_options.endDate
                            "
                            wrapper-class="p-5 pl-2 mt-2 pt-0 pb-0 mb-2"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-col>
                      </vs-row>
                    </vs-col> -->
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit ==
                      true
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Anniversary Year
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'anniversary_year'
                                )
                              "
                              v-bind:name="'anniversary_year' + index"
                              value="anniversary_year"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Recurring Monthly
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'recurring_monthly'
                                )
                              "
                              v-bind:name="'recurring_monthly' + index"
                              value="recurring_monthly"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Recurring Quarters
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'recurring_quarters'
                                )
                              "
                              v-bind:name="'recurring_quarters' + index"
                              value="recurring_quarters"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit ==
                      true
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Calendar Year
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'calendar_year'
                                )
                              "
                              v-bind:name="'calendar_year' + index"
                              value="calendar_year"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-0 pb-3 "
                          vs-sm="3 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q1
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'q1'
                                )
                              "
                              v-bind:name="'q1' + index"
                              value="q1"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q2
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'q2'
                                )
                              "
                              v-bind:name="'q2' + index"
                              value="q2"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3 pl-2"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q3
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'q3'
                                )
                              "
                              v-bind:name="'q3' + index"
                              value="q3"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q4
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.pointsCategories[index]
                                    .manage_spend_limit_options,
                                  'q4'
                                )
                              "
                              v-bind:name="'q4' + index"
                              value="q4"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <!-- <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit
                    "
                    class="ml-2 mt-2"
                  >
                    <p>Does the spend limit apply to other categories?</p>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="9">
                        <vs-col
                          class="mr-2"
                          vs-lg="2 p-3 pt-2 pl-2"
                          vs-sm="4 pb-3 pt-2"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Yes
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options
                                  .apply_spend_limit_to_other_categories
                              "
                              v-bind:name="'true' + index"
                              value="true"
                              @click="changeSpendLimitOption(index, 'group')"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="2 pt-2 pb-3 " vs-sm="4 pt-2 pb-3">
                          <label class="container" style="padding-left: 24px"
                            >No
                            <input
                              type="radio"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .manage_spend_limit_options
                                  .apply_spend_limit_to_other_categories
                              "
                              v-bind:name="'false' + index"
                              value="false"
                              @click="changeSpendLimitOption(index, 'single')"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit &&
                      cardDetails.pointsCategories[index]
                        .manage_spend_limit_options
                        .apply_spend_limit_to_other_categories == 'true'
                    "
                    class="mt-2 ml-2"
                  >
                    <p>Choose other categories included in limit</p>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.pointsCategories[index].manage_spend_limit &&
                      cardDetails.pointsCategories[index]
                        .manage_spend_limit_options
                        .apply_spend_limit_to_other_categories == 'true'
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="5 ml-2 mr-3">
                        <div class="mt-1">
                          <select
                            v-model="groupCat"
                            @change="AddCategoryToGroupHandler(index)"
                            class="w-full posSelect p-3"
                          >
                            <option
                              v-for="cat in pointsCategoriesOption"
                              :key="cat._id"
                              :value="cat"
                            >
                              {{ cat.name }}
                            </option>
                          </select>
                        </div>
                         <vs-col
                          vs-lg="2 p-3 pt-2 pl-4 "
                          vs-sm="3 pb-3 pt-2"
                          vs-xs="12"
                          class="optionlimit"
                          :key="ind"
                          v-for="(cat, ind) in cardDetails.pointsCategories[
                            index
                          ].groupCategories"
                        >
                          <label class="container" style="padding-left: 24px">
                            <div
                              v-if="
                                cardDetails.pointsCategories[index]
                                  .groupCategories[
                                  ind
                                ].name
                                  ? cardDetails.pointsCategories[index]
                                      
                                      .groupCategories[ind].name.length <= 10
                                  : 'NA'
                              "
                            >
                              {{
                                cardDetails.pointsCategories[index]
                                  .groupCategories[
                                  ind
                                ].name
                                  ? cardDetails.pointsCategories[index]
                                      
                                      .groupCategories[ind].name
                                  : "NA"
                              }}
                            </div>
                            <div v-else>
                              {{
                                cardDetails.pointsCategories[
                                  index
                                ].groupCategories[
                                  ind
                                ].name.substring(0, 10) + ".."
                              }}
                            </div>
                            <input
                              class="mt-3"
                              type="checkbox"
                              v-bind:name="'multiple_use_unlimited' + index"
                              value="multiple_use_unlimited"
                              v-model="
                                cardDetails.pointsCategories[index]
                                  .groupCategories[
                                  ind
                                ].category_in_limit
                              "
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col> 
                      </vs-col>
                      <vs-col>
                        <vs-row
                          v-for="categor in cardDetails.pointsCategories[index]
                            .groupCategories"
                          :key="categor._id"
                          :value="categor.name"
                        >
                          <h6>{{ categor.name }}</h6>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-row> -->

                  <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row>

                  <!-- <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row> -->
                </vs-row>
                <vs-row>
                  <div
                    v-show="errors.pointCategories.success"
                    class="ml-2 mb-3"
                  >
                    <div id="errFont" class="dangerColor mt-2">
                      <span>{{ errors.pointCategories.msg }}</span>
                    </div>
                  </div>
                </vs-row>
                <!-- <vs-row>
                  <div
                    class="flex flex-wrap-reverse items-center ml-2 mt-3 cursor"
                    @click="addPointCategory('single')"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                  </div>
                </vs-row> -->
                <vs-row>
                  <div
                    class="flex flex-wrap-reverse items-center ml-2 mt-3 cursor"
                    @click="addPointCategory('single')"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Bonus Category</h6>
                  </div>
                  <div
                    class="flex flex-wrap-reverse items-center ml-6 mt-3 cursor"
                    @click="addPointCategory('group')"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Bonus Category Group</h6>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
              <div class="border-top mt-10 ml-5 mb-1"></div>
            </vs-col>
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <h4 class="ml-5 mt-10 mb-5">Targeted Offers</h4>
              </vs-col>
            </vs-row>
            <vs-row>
              <div
                class="flex flex-wrap-reverse items-center ml-5 mt-3 cursor"
                @click="addMainTargetedOffer"
              >
                <PlusSquareIcon color="white" />
                <h6 class="ml-2 mt-1 cursor">Add Targeted Offer</h6>
              </div>
            </vs-row>
            <vs-row>
              <vs-col vs-lg="12 p-3" vs-sm="12 p-3">
                <vs-row
                  :key="index"
                  v-for="(category, index) in cardDetails.targeted_offers"
                >
                  <!-- <vs-col vs-lg="3" vs-sm="4" vs-xs="12" class="mt-5 px-2"> -->
                  <vs-row class="mt-5 mb-3 ml-2">
                    <vs-col vs-lg="7">
                      <h6 class="mt-1">Targeted Offer {{ index + 1 }}</h6>
                    </vs-col>
                    <vs-col vs-lg="4">
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-3
                          mr-5
                          cursor
                        "
                        @click="
                          cardDetails.targeted_offers.splice(index, 1),
                            updateAllTargetedlimitCategories()
                        "
                      >
                        <MinusSquareIcon color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove
                        </div>
                      </div>
                    </vs-col>
                  </vs-row>
                  <vs-row
                    :key="Bonusindex"
                    v-for="(bonuscategory, Bonusindex) in cardDetails
                      .targeted_offers[index].bonusCategory"
                  >
                    <vs-row
                      :key="categoryIndex"
                      v-for="(categories, categoryIndex) in cardDetails
                        .targeted_offers[index].bonusCategory[Bonusindex]
                        .categories"
                    >
                      <div class="mt-5 px-2">
                        <select
                          v-model="
                            cardDetails.targeted_offers[index].bonusCategory[
                              Bonusindex
                            ].categories[categoryIndex].points_category
                          "
                          @change="targetedofferchangehandler(Bonusindex)"
                          class="w-full posSelect p-3"
                        >
                          <option
                            v-for="cat in pointsCategoriesOption"
                            :key="cat._id"
                            :value="cat._id"
                          >
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                      <!-- </vs-col> -->
                      <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-0
                          cursor
                          my-6
                        "
                      >
                        <vx-tooltip
                          text="Press the button to add a new point category if you did not find it in the list"
                          position="top"
                        >
                          <vs-row>
                            <PlusSquareIcon
                              color="white"
                              @click="
                                showPointCategryModalForTargetedOffer(
                                  index,
                                  Bonusindex,
                                  categoryIndex
                                )
                              "
                            />
                          </vs-row>
                        </vx-tooltip>
                      </div>
                      <div>
                        <vs-input
                          maxlength="3"
                          type="number"
                          min="0"
                          class="p-5 pl-2"
                          placeholder="Percentage"
                          v-model="
                            cardDetails.targeted_offers[index].bonusCategory[
                              Bonusindex
                            ].categories[categoryIndex].percentage
                          "
                          @keydown="validateNumeric($event, true)"
                        />
                      </div>
                      <div>
                        <vs-input-number
                          v-model="
                            cardDetails.targeted_offers[index].bonusCategory[
                              Bonusindex
                            ].categories[categoryIndex].multiplier
                          "
                          class="inline-flex m-6 mr-6"
                          min="0"
                        />
                      </div>

                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-3
                          mr-5
                          cursor
                        "
                        @click="
                          updateAllTargetedlimitCategories(),
                            removeTargetedOfferCategory(
                              index,
                              Bonusindex,
                              categoryIndex
                            )
                        "
                      >
                        <MinusSquareIcon color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove
                        </div>
                      </div>
                      <vs-row class="ml-0">
                        <vs-col vs-lg="9">
                          <vs-col
                            vs-lg="4"
                            class="mb-3"
                            :key="Dynamicindex"
                            v-for="(dyn, Dynamicindex) in cardDetails
                              .targeted_offers[index].bonusCategory[Bonusindex]
                              .categories[categoryIndex].dynamic_bonus_category"
                          >
                            <vs-row>
                              <vs-checkbox
                                class="ml-2 mb-3"
                                vs-name="global_dynamic_bonus_category"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex].categories[
                                    categoryIndex
                                  ].dynamic_bonus_category[Dynamicindex].isAdded
                                "
                              />
                              <div class="text-white smalltext">
                                Dynamic Bonus Category {{ Dynamicindex + 1 }}
                              </div>
                            </vs-row>
                            <!-- <div>
                              <label
                                class="container"
                                style="padding-left: 24px"
                                >Dynamic Bonus Category {{ Dynamicindex + 1 }}
                                <input
                                  type="checkbox"
                                  v-model="
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex].categories[
                                      categoryIndex
                                    ].dynamic_bonus_category[Dynamicindex]
                                      .isAdded
                                  "
                                  v-bind:name="
                                    'dynamic_bonus_category' +
                                    index +
                                    Bonusindex +
                                    categoryIndex +
                                    Dynamicindex
                                  "
                                  value="true"
                                />
                                <span
                                  class="checkmark"
                                  style="border-radius: 2px"
                                ></span>
                              </label>
                            </div> -->
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].category_type == 'group'
                      "
                    >
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-2
                          mt-0
                          mb-3
                          cursor
                        "
                        @click="addTargetedOfferCategory(index, Bonusindex)"
                      >
                        <PlusSquareIcon color="white" />
                        <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                      </div>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].points_category != ''
                      "
                    >
                      <!-- <vs-col vs-lg="3" vs-sm="3"> -->
                      <div class="mt-1">
                        <vs-row>
                          <vs-checkbox
                            class="ml-2 mb-3"
                            v-model="
                              cardDetails.targeted_offers[index].bonusCategory[
                                Bonusindex
                              ].manage_spend_limit
                            "
                            vs-name="target_manage_spend_limit"
                          />

                          <div class="text-white smalltext">
                            Manage Spend Limit
                          </div>
                        </vs-row>
                      </div>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit
                      "
                    >
                      <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <div class="mt-2 ml-2">Spend Limit</div>
                          <vs-input
                            type="number"
                            min="0"
                            id="transparent"
                            class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                            v-model="
                              cardDetails.targeted_offers[index].bonusCategory[
                                Bonusindex
                              ].manage_spend_limit_options.spend_limit
                            "
                          />
                        </vs-col>

                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <div class="mt-2 ml-2">Points Limit</div>
                          <vs-input
                            type="number"
                            min="0"
                            id="transparent"
                            class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                            v-model="
                              cardDetails.targeted_offers[index].bonusCategory[
                                Bonusindex
                              ].manage_spend_limit_options.points_limit
                            "
                          />
                        </vs-col>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit
                      "
                    >
                      <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                        <vs-row>
                          <vs-col vs-lg="6" vs-sm="5" vs-xs="12" class="mr-0">
                            <label class="ml-2">Beginning Date </label>
                            <div
                              v-if="
                                cardDetails.targeted_offers[index]
                                  .bonusCategory[Bonusindex]
                                  .manage_spend_limit_options.date_type !=
                                'calendar_year'
                              "
                            >
                              <Datepicker
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.beginningDate
                                "
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                            <div v-else>
                              <Datepicker
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                          </vs-col>
                          <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                            <label class="ml-2">End Date </label>
                            <div
                              v-if="
                                cardDetails.targeted_offers[index]
                                  .bonusCategory[Bonusindex]
                                  .manage_spend_limit_options.date_type !=
                                'calendar_year'
                              "
                            >
                              <Datepicker
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.endDate
                                "
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                            <div v-else>
                              <Datepicker
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit == true
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Anniversary Year
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'anniversary_year'
                                  )
                                "
                                v-bind:name="
                                  'target_anniversary_year' + index + Bonusindex
                                "
                                value="anniversary_year"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Recurring Monthly
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'recurring_monthly'
                                  )
                                "
                                v-bind:name="
                                  'target_recurring_monthly' +
                                  index +
                                  Bonusindex
                                "
                                value="recurring_monthly"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-0 pb-3 "
                            vs-sm="3 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Recurring Quarters
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'recurring_quarters'
                                  )
                                "
                                v-bind:name="
                                  'target_recurring_quarters' +
                                  index +
                                  Bonusindex
                                "
                                value="recurring_quarters"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit == true
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Calendar Year
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'calendar_year'
                                  )
                                "
                                v-bind:name="
                                  'target_calendar_year' + index + Bonusindex
                                "
                                value="calendar_year"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-0 pb-3 "
                            vs-sm="3 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q1
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q1'
                                  )
                                "
                                v-bind:name="'target_q1' + index + Bonusindex"
                                value="q1"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-1 pb-3"
                            vs-sm="4 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q2
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q2'
                                  )
                                "
                                v-bind:name="'target_q2' + index + Bonusindex"
                                value="q2"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-1 pb-3"
                            vs-sm="4 pt-1 pb-3 pl-2"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q3
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q3'
                                  )
                                "
                                v-bind:name="'target_q3' + index + Bonusindex"
                                value="q3"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-1 pb-3"
                            vs-sm="4 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q4
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q4'
                                  )
                                "
                                v-bind:name="'target_q4' + index + Bonusindex"
                                value="q4"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-lg="9">
                        <div class="border-top mt-5 ml-2 mb-1"></div>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <!-- <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row> -->
                  <vs-row>
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-2
                        mt-3
                        cursor
                      "
                      @click="addTargetedOfferBonusCategory(index, 'single')"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Bonus Category</h6>
                    </div>
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-6
                        mt-3
                        cursor
                      "
                      @click="addTargetedOfferBonusCategory(index, 'group')"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Bonus Category Group</h6>
                    </div>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row>
                </vs-row>
                <vs-row>
                  <div v-show="errors.targetedOffers.success" class="ml-2 mb-3">
                    <div id="errFont" class="dangerColor mt-2">
                      <span>{{ errors.targetedOffers.msg }}</span>
                    </div>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>

          <vs-row v-if="SubCategorypoints.show == true">
            <vs-row>
              <vs-col vs-offset="7">
                <transition name="fade">
                  <div class="modal">
                    <div class="modal__backdrop">
                      <div class="modal__dialog">
                        <div class="modal__header">
                          <slot name="header">
                            <h4 style="margin-left: 20px">
                              Manage Subcategories
                            </h4>
                            <vue-load-image>
                              <img
                                class="ml-1 topright"
                                slot="image"
                                :src="require('@/assets/images/x/close.png')"
                                height="50"
                                width="47"
                                @click="BacktoMainCategories()"
                              />
                            </vue-load-image>
                          </slot>
                        </div>

                        <div class="modal__body">
                          <vs-row class="catBgClr mx-4">
                            <vs-col vs-lg="12" vs-sm="8" vs-xs="12">
                              <p class="pl-5 pb-6 pt-0 mb-0 mt-2 whiteText">
                                You may drag the fields to change the order
                              </p>
                            </vs-col>
                            <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

                            <vs-row>
                              <vs-col vs-lg="8" vs-sm="8" class="">
                                <vs-row>
                                  <vs-col vs-lg="12" vs-sm="12" vs-xs="9">
                                    <div class="my-2 ml-5">Category</div>
                                    <vs-input
                                      id="transparent"
                                      class="w-full p-3 ml-2"
                                      :disabled="true"
                                      v-model="SubCategorypoints.name"
                                    />
                                  </vs-col>
                                </vs-row>
                              </vs-col>
                            </vs-row>

                            <vs-row>
                              <div
                                class="
                                  flex flex-wrap-reverse
                                  items-center
                                  ml-5
                                  cursor
                                  mt-4
                                  mb-3
                                  pt-0
                                "
                                @click="addNewSubCategory()"
                              >
                                <PlusSquareIcon color="white" />
                                <h6 class="ml-2 mt-1 cursor">
                                  Add Subcategory
                                </h6>
                              </div>
                            </vs-row>
                            <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

                            <draggable
                              v-model="SubCategorypoints.subcategory"
                              v-bind="dragOptions"
                              class="w-full"
                            >
                              <transition-group
                                type="transition"
                                name="flip-list"
                              >
                                <vs-row
                                  :key="index"
                                  v-for="(
                                    category, index
                                  ) in SubCategorypoints.subcategory"
                                  class="ml-5"
                                >
                                  <vs-col
                                    vs-lg="8"
                                    vs-sm="8"
                                    vs-xs="6"
                                    class="pr-6"
                                    id="inputBorder"
                                  >
                                    <vs-row>
                                      <vs-col class="mt-6 pt-1" vs-lg="1">
                                        <MenuIcon class="mt-6" />
                                      </vs-col>
                                      <vs-col vs-lg="11">
                                        <div class="my-2 pt-1 ml-1">
                                          Subcategory {{ index + 1 }}
                                        </div>

                                        <select
                                          v-if="
                                            pointsCategoriesOption.length > 0
                                          "
                                          v-model="
                                            SubCategorypoints.subcategory[index]
                                              .category
                                          "
                                          :class="{
                                            'w-full posSelect  pl-3': true,
                                          }"
                                          @change="handleSelect(index)"
                                        >
                                          <option selected>
                                            {{
                                              SubCategorypoints.subcategory[
                                                index
                                              ].name
                                            }}
                                          </option>
                                          <option
                                            v-for="categor in pointsCategoriesOption"
                                            :key="categor._id"
                                            :value="categor._id"
                                          >
                                            {{ categor.name }}
                                          </option>
                                        </select>
                                      </vs-col>
                                    </vs-row>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-sm="3"
                                    vs-xs="12"
                                    vs-type="flex"
                                    vs-justify="flex-start"
                                  >
                                    <div
                                      v-if="
                                        SubCategorypoints.subcategory[index]
                                          .isDeleteable ||
                                        SubCategorypoints.subcategory[index]
                                          .isDeleteable == undefined
                                      "
                                      class="
                                        flex flex-wrap-reverse
                                        items-center
                                        cursor
                                        mt-5
                                        pl-4
                                      "
                                      @click="removeSubCategory(index)"
                                    >
                                      <MinusSquareIcon
                                        color="white"
                                        class="mt-5"
                                      />
                                      <div
                                        class="
                                          addCardFont
                                          font-semibold
                                          ml-3
                                          cursor
                                          mt-6
                                        "
                                      >
                                        Remove
                                      </div>
                                    </div>

                                    <div
                                      v-if="
                                        SubCategorypoints.subcategory[index]
                                          .isDeleteable == false
                                      "
                                      class="cursor mt-5 pt-0 ml-1"
                                      style="opacity: 0.3"
                                    >
                                      <vx-tooltip
                                        text="This category cannot be deleted since it is in use by cards"
                                        position="top"
                                      >
                                        <vs-row>
                                          <MinusSquareIcon
                                            color="white"
                                            class="mt-5"
                                          />
                                          <div
                                            class="
                                              addCardFont
                                              font-semibold
                                              ml-3
                                              cursor
                                              mt-6
                                            "
                                          >
                                            Remove
                                          </div>
                                        </vs-row>
                                      </vx-tooltip>
                                    </div>
                                  </vs-col>
                                </vs-row>
                              </transition-group>
                            </draggable>
                            <div
                              v-show="errors.subCategory.success"
                              class="ml-16 mb-3"
                            >
                              <div id="errFont" class="dangerColor mt-3 ml-1">
                                <span>{{ errors.subCategory.msg }}</span>
                              </div>
                            </div>
                          </vs-row>

                          <vs-row class="mt-16 pr-2 mb-1" vs-justify="center">
                            <vs-col vs-lg="9" vs-sm="9" vs-xs="0"> </vs-col>
                            <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
                              <vs-button
                                style="width: 138px"
                                @click="updateCardSubCategories()"
                                >Save</vs-button
                              >
                            </vs-col>
                          </vs-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </vs-col>
            </vs-row>
          </vs-row>
        </tab-content>

        <tab-content
          title=""
          class="mb-5 tabCard"
          :before-change="beforePerksTabChange"
        >
          <vs-row>
            <vs-row class="ml-3">
              <h3 class="p-5">Perks</h3>
            </vs-row>
            <div v-show="errors.perks.success" class="ml-5 mb-3">
              <div id="errFont" class="dangerColor mt-3 ml-3">
                <span>{{ errors.perks.msg }}</span>
              </div>
            </div>
            <vs-row :key="index" v-for="(category, index) in cardDetails.perks">
              <vs-row v-if="cardDetails.perks[index].show == true">
                <vs-col vs-lg="6 p-3" vs-sm="12 p-3">
                  <vs-row class="inputContainer">
                    <div class="addCardFont font-semibold ml-5">Category</div>
                    <vs-input
                      class="w-full p-5 pt-3"
                      placeholder="e.g. Free Night"
                      maxLength="30"
                      v-model="cardDetails.perks[index].category"
                    />
                  </vs-row>

                  <vs-row class="inputContainer">
                    <vs-row>
                      <vs-col vs-lg="6">
                        <div class="addCardFont font-semibold ml-5">
                          Estimated Value
                        </div>
                      </vs-col>
                      <vs-col vs-lg="6">
                        <vs-row
                          class="
                            vs-row
                            inputContainer
                            max-height-5-24
                            alignRight
                            pr-5
                          "
                          vs-type="flex"
                        >
                          <vs-checkbox
                            @click="setPerkEstimatedNA(index)"
                            :checked="cardDetails.perks[index].na_estimated_val"
                            vs-name="rule-type"
                            :disabled="cardDetails.perks[index].disable"
                          />
                          <div class="text-white">N/A</div>
                        </vs-row>
                      </vs-col>
                    </vs-row>

                    <vs-input
                      placeholder="$150"
                      class="w-full p-5 pt-3"
                      type="number"
                      min="0"
                      maxlength="20"
                      @keydown="validateNumeric($event)"
                      v-model="cardDetails.perks[index].estimated_value"
                      :disabled="
                        cardDetails.perks[index].na_estimated_val ||
                        cardDetails.perks[index].disable
                      "
                    />
                  </vs-row>

                  <vs-row class="inputContainer">
                    <div class="addCardFont font-semibold ml-5">Key Date</div>
                    <select
                      v-if="cardDetails.perks[index].token == undefined"
                      v-model="cardDetails.perks[index].key_date"
                      class="w-full posSelect m-5 mt-3 mb-2 px-2"
                      v-on:change="
                        onKeyDateChanged(
                          cardDetails.perks[index].key_date,
                          index
                        )
                      "
                      :disabled="cardDetails.perks[index].disable"
                    >
                      <option
                        v-for="p in perks_key_date_option"
                        :key="p.value"
                        :value="p.value"
                      >
                        {{ p.name }}
                      </option>
                    </select>

                    <select
                      v-if="cardDetails.perks[index].token != undefined"
                      v-model="cardDetails.perks[index].key_date"
                      class="w-full posSelect m-5 mt-3 mb-2 px-2"
                      v-on:change="
                        onKeyDateChanged(
                          cardDetails.perks[index].key_date,
                          index
                        )
                      "
                      :disabled="cardDetails.perks[index].disable"
                    >
                      <option
                        v-for="p in earned_perks_key_date_option"
                        :key="p.value"
                        :value="p.value"
                      >
                        {{ p.name }}
                      </option>
                    </select>

                    <vs-row
                      class="mb-5"
                      v-if="
                        cardDetails.perks[index].key_date != '' &&
                        cardDetails.perks[index].key_date != 'custom_date' &&
                        cardDetails.perks[index].key_date != 'NA' &&
                        cardDetails.perks[index].key_date !=
                          'elite_year_january' &&
                        cardDetails.perks[index].key_date !=
                          'elite_year_february' &&
                        cardDetails.perks[index].key_date !=
                          'elite_year_march' &&
                        cardDetails.perks[index].key_date_addition &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Weeks
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            maxlength="20"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].key_date_addition.weeks
                            "
                          />
                        </vs-row>
                      </vs-col>

                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Months
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            maxlength="20"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].key_date_addition.months
                            "
                          />
                        </vs-row>
                      </vs-col>

                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Years
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            maxlength="20"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].key_date_addition.years
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>

                    <vs-row
                      class="pb-5"
                      v-if="
                        cardDetails.perks[index].key_date == 'custom_date' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="pb-3"
                        :key="date_index"
                        v-for="(custom_date, date_index) in cardDetails.perks[
                          index
                        ].custom_dates"
                      >
                        <Datepicker
                          :disabled-dates="
                            cardDetails.perks[index].custom_dates[
                              date_index - 1
                            ] && {
                              to: new Date(
                                new Date(
                                  cardDetails.perks[index].custom_dates[
                                    date_index - 1
                                  ]
                                ).getTime() +
                                  60 * 60 * 24 * 1000
                              ),
                            }
                          "
                          v-model="
                            cardDetails.perks[index].custom_dates[date_index]
                          "
                          wrapper-class="p-5 mt-0 pt-0 pb-0"
                          calendar-class="posCalendar"
                          input-class="bgColorInput"
                          placeholder="MM/DD/YYYY"
                          format="MM/dd/yyyy"
                        />
                        <div
                          class="
                            flex flex-wrap-reverse
                            items-center
                            cursor
                            mt-1
                          "
                          @click="
                            cardDetails.perks[index].custom_dates.splice(
                              date_index,
                              1
                            )
                          "
                        >
                          <MinusSquareIcon size="20" color="white" />
                          <div class="addCardFont font-semibold ml-2 cursor">
                            Remove Date
                          </div>
                        </div>
                      </vs-row>

                      <div
                        class="flex flex-wrap-reverse items-center ml-5 cursor"
                        @click="cardDetails.perks[index].custom_dates.push('')"
                      >
                        <PlusSquareIcon size="20" color="white" />
                        <h6 class="ml-2 cursor">Add Date</h6>
                      </div>
                    </vs-row>

                    <vs-row>
                      <div class="addCardFont font-semibold ml-5">
                        Date Type
                      </div>
                      <select
                        v-model="cardDetails.perks[index].date_type"
                        class="w-full posSelect m-5 mb-3 mt-3 px-2"
                        :disabled="
                          cardDetails.perks[index].key_date == 'NA' ||
                          cardDetails.perks[index].disable
                        "
                      >
                        <option
                          v-for="pd in perks_date_type_option"
                          :key="pd.value"
                          :value="pd.value"
                        >
                          {{ pd.name }}
                        </option>
                      </select>
                    </vs-row>

                    <vs-row>
                      <div class="addCardFont font-semibold ml-5 mt-2">
                        Call to Action Button
                      </div>

                      <select
                        v-model="cardDetails.perks[index].call_to_action"
                        class="w-full posSelect m-5 mb-2 mt-3 px-2"
                        @change="CallToActionButton(index)"
                        :disabled="cardDetails.perks[index].disable"
                      >
                        <template
                          v-if="
                            cardDetails.perks[index].token &&
                            cardDetails.perks[index].token != ''
                          "
                        >
                          <option
                            v-for="pc in earned_perks_call_to_action_options"
                            :key="pc.value"
                            :value="pc.value"
                          >
                            {{ pc.name }}
                          </option>
                        </template>
                        <template v-else>
                          <option
                            v-for="pc in perks_call_to_action_options"
                            :key="pc.value"
                            :value="pc.value"
                          >
                            {{ pc.name }}
                          </option>
                        </template>
                      </select>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_earned_status' &&
                        !cardDetails.perks[index].disable
                      "
                      class="vs-row inputContainer max-height-5-24 ml-4"
                      vs-type="flex"
                    >
                      <!-- <vs-checkbox
                        v-model="
                          cardDetails.perks[index].earned_status.add_new_perk
                        "
                        vs-name="rule-type"
                        class="pt-1"
                        @change="AddnewPerkhandler(index)"
                      /> -->
                      <div class="font-semibold ml-2 pt-5 text-white">
                        Add Earned Perk
                      </div>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_usage' &&
                        cardDetails.perks[index].track_usage &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5" vs-sm="6 p-3">
                          <label class="container"
                            >Single Use (One Time-Only)
                            <input
                              type="radio"
                              v-bind:name="'single_use_one_time' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="single_use_one_time"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-3 " vs-sm="6 pt-3 pb-2">
                          <label class="container"
                            >Single Use
                            <input
                              type="radio"
                              v-bind:name="'single_use' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="single_use"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5 pt-3 " vs-sm="6 p-3">
                          <label class="container"
                            >Multiple use (limited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_limited' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="multiple_use_limited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="6 pt-3 pb-3">
                          <label class="container"
                            >Multiple use (unlimited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_unlimited' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="multiple_use_unlimited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_usage' &&
                        cardDetails.perks[index].track_usage &&
                        cardDetails.perks[index].track_usage.option_value ==
                          'multiple_use_limited' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Choose # of limit
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].track_usage
                                .multiple_use_limit
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'mark_as_enrolled' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5" vs-sm="6 p-3">
                          <label class="container"
                            >Enrollment With No Expiration
                            <input
                              type="radio"
                              v-bind:name="
                                'enrollment_with_no_expiration' + index
                              "
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .option_value
                              "
                              value="enrollment_with_no_expiration"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-3 pb-3" vs-sm="6 pt-3 pb-3">
                          <label class="container"
                            >Enrollment With Expiration
                            <input
                              type="radio"
                              v-bind:name="'enrollment_with_expiration' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .option_value
                              "
                              value="enrollment_with_expiration"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row>
                        <div class="addCardFont font-semibold ml-5 mt-2">
                          Track Usage Type
                        </div>
                      </vs-row>
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5" vs-sm="6 p-3">
                          <label class="container"
                            >Single Use (One Time-Only)
                            <input
                              type="radio"
                              v-bind:name="'single_use_one_time' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="single_use_one_time"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-3 " vs-sm="6 pt-3 pb-2">
                          <label class="container"
                            >Single Use
                            <input
                              type="radio"
                              v-bind:name="'single_use' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="single_use"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5 pt-3 " vs-sm="6 p-3">
                          <label class="container"
                            >Multiple use (limited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_limited' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="multiple_use_limited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="6 pt-3 pb-3">
                          <label class="container"
                            >Multiple use (unlimited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_unlimited' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="multiple_use_unlimited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row
                        v-if="
                          cardDetails.perks[index].call_to_action ==
                            'mark_as_enrolled' &&
                          cardDetails.perks[index].mark_as_enrolled &&
                          cardDetails.perks[index].mark_as_enrolled
                            .track_usage_type == 'multiple_use_limited' &&
                          !cardDetails.perks[index].disable
                        "
                      >
                        <vs-col vs-lg="4">
                          <vs-row>
                            <div class="addCardFont font-semibold ml-5 mb-1">
                              Choose # of limit
                            </div>
                          </vs-row>
                          <vs-row>
                            <vs-input
                              class="w-full px-5"
                              type="number"
                              min="0"
                              @keydown="validateNumeric($event)"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .multiple_use_limit
                              "
                            />
                          </vs-row>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].date_type == 'expiration' &&
                        cardDetails.perks[index].key_date ==
                          'enrollment_date' &&
                        cardDetails.perks[index].call_to_action ==
                          'mark_as_enrolled' &&
                        cardDetails.perks[index].mark_as_enrolled
                          .option_value == 'enrollment_with_expiration' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row>
                        <div
                          class="
                            addCardFont
                            whiteText
                            font-semibold
                            ml-5
                            mt-2
                            mb-1
                          "
                        >
                          Master Cut-off Date
                        </div>
                      </vs-row>
                      <vs-row>
                        <Datepicker
                          v-model="
                            cardDetails.perks[index].mark_as_enrolled
                              .master_cutoff_date
                          "
                          wrapper-class="w-full p-5 mt-2 pt-0"
                          calendar-class="posCalendar"
                          input-class="bgColorInput"
                          placeholder="MM/DD/YYYY"
                          format="MM/dd/yyyy"
                        />
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_earned_tiers' &&
                        cardDetails.perks[index].track_earned_tiers &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                        vs-type="flex"
                      >
                        <vs-col
                          vs-lg="6 p-3 pl-5"
                          vs-sm="6 pb-3 pl-3 pr-3 pt-1"
                        >
                          <label class="container"
                            >Multiple Use (Unlimited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_unlimited' + index"
                              v-model="
                                cardDetails.perks[index].track_earned_tiers
                                  .option_value
                              "
                              value="multiple_use_unlimited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-1 pb-3 pl-8" vs-sm="6 pt-1 pb-3">
                          <label class="container"
                            >Multiple Use (Limited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_limited' + index"
                              v-model="
                                cardDetails.perks[index].track_earned_tiers
                                  .option_value
                              "
                              value="multiple_use_limited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_earned_tiers' &&
                        cardDetails.perks[index].track_earned_tiers
                          .option_value != '' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="6">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Input text
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="text"
                            placeholder="e.g., 1,000 TQPs"
                            v-model="
                              cardDetails.perks[index].track_earned_tiers
                                .input_text
                            "
                          />
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Choose # of limit
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].track_earned_tiers
                                .number_of_limit
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6 p-3" vs-sm="12 p-3">
                  <vs-row>
                    <div class="addCardFont font-semibold ml-4 cursor pb-5">
                      Description
                    </div>
                    <Editor
                      :disabled="cardDetails.perks[index].disable"
                      v-model="cardDetails.perks[index].description"
                      api-key="5nhm4pgf51fpuh0eu4mibhh6y67oxybsqctow1rpfvperrft"
                      :init="{
                        selector: 'textarea',
                        content_style: 'body, body a { color: white }',
                        width: '95%',
                        menubar: false,
                        plugins: 'link paste autolink',
                        toolbar:
                          'bold italic underline strikethrough | link anchor',
                      }"
                    />
                  </vs-row>

                  <vs-row class="mt-5">
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-6
                        cursor
                        mt-1
                      "
                      @click="removePerk(index)"
                    >
                      <MinusSquareIcon color="white" />
                      <div class="addCardFont font-semibold ml-3 cursor">
                        Remove
                      </div>
                    </div>
                  </vs-row>
                  <vs-row
                    class="vs-row inputContainer pt-2 max-height-5-24 ml-5"
                    vs-type="flex"
                  >
                    <vs-checkbox
                      @click="setPerkDisplay(index)"
                      :checked="!cardDetails.perks[index].hide_on_dashboard"
                      vs-name="rule-type"
                      class="mt-4"
                    />
                    <div class="font-semibold ml-2 pt-4 text-white">
                      Display on Dashboard
                    </div>
                  </vs-row>
                  <vs-row>
                    <vs-button
                      id="buttontext"
                      width="90%"
                      class="items-center cursor ml-4 mt-10"
                      @click="showBonusCategoryModel(index, 'perks')"
                      >Manage BonusCategories</vs-button
                    >
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.perks[index].key_date != 'custom_date' &&
                      cardDetails.perks[index].key_date != 'NA'
                    "
                    class="vs-row inputContainer pt-2 max-height-5-24 ml-5"
                    vs-type="flex"
                  >
                    <vs-checkbox
                      @click="setPerkExpiration(index)"
                      :checked="
                        cardDetails.perks[index].no_first_year_expiration
                      "
                      vs-name="rule-type"
                      class="mt-4"
                    />
                    <div class="font-semibold ml-2 pt-4 text-white">
                      No First Year Expiration
                    </div>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-row>

            <!-- <modal
                :pointsCategoriesOption="pointsCategoriesOption"
                :showModal="showModal"
                :index="bonusIndex"
                :bonusCategory="cardDetails.perks"
                @close_modal_success="closeModalonSuccess"
                @close_modal_dismiss="closeModalonDismiss"
              ></modal> -->
            <vs-row class="ml-3">
              <div
                class="flex flex-wrap-reverse items-center ml-5 mt-3 cursor"
                @click="addPerk"
              >
                <PlusSquareIcon color="white" />
                <h6 class="ml-2 mt-1 cursor">Add Perk</h6>
              </div>
            </vs-row>
          </vs-row>
        </tab-content>

        <tab-content title="" class="mb-5 tabCard">
          <vs-row>
            <vs-row>
              <h3
                class="p-5 pb-2"
                v-if="modifiedList && modifiedList.length > 0"
              >
                Add Active Rules
              </h3>
            </vs-row>
            <vs-row>
              <p
                class="p-5"
                id="whiteText"
                v-if="modifiedList && modifiedList.length > 0"
              >
                Do you want to add active rules for this card?
              </p>
              <p
                class="p-5"
                id="whiteText"
                v-if="modifiedList && modifiedList.length == 0"
              >
                No active rules available for this Issuer
              </p>
            </vs-row>
            <vs-row v-if="modifiedList && modifiedList.length > 0">
              <vs-row v-if="errors.rules.success">
                <p id="errFont" class="p-5 py-3 dangerColor">
                  {{ errors.rules.msg }}
                </p>
              </vs-row>
              <vs-row id="whiteText">
                <vs-radio
                  v-model="cardDetails.newRuleCheck"
                  vs-name="rule"
                  vs-value="Yes"
                  class="m-5"
                  @change="updateRule('Yes')"
                  >Yes</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.newRuleCheck"
                  vs-name="rule"
                  vs-value="No"
                  class="m-5"
                  @change="updateRule('No')"
                  >No</vs-radio
                >
              </vs-row>
              <vs-row
                :key="index"
                v-for="(rule, index) in cardDetails.rules"
                v-bind:class="{ hidder: cardDetails.newRuleCheck == 'No' }"
              >
                <vs-col
                  vs-lg="6"
                  vs-sm="12"
                  class="px-3 pl-4"
                  id="ruleOptionContainer"
                >
                  <div class="my-2">Active Rule {{ index + 1 }}</div>
                  <select
                    v-model="cardDetails.rules[index].rule"
                    class="w-full posSelect p-3"
                    @change="handleCardFilter"
                    :disabled="cardsList.length == 0"
                  >
                    <option
                      v-for="item in modifiedList"
                      v-bind:key="item._id"
                      :value="item._id"
                    >
                      {{ item.rule }}
                    </option>
                  </select>
                </vs-col>
                <vs-col vs-lg="3" vs-sm="6">
                  <div class="my-2 ml-5">Effective Dates</div>
                  <Datepicker
                    v-model="cardDetails.rules[index].effectiveDate"
                    wrapper-class="p-5 mt-0 pt-0"
                    calendar-class="posCalendar"
                    input-class="bgColorInput"
                    placeholder="MM/DD/YYYY"
                    format="MM/dd/yyyy"
                  />
                </vs-col>
                <vs-col vs-lg="3" vs-sm="6">
                  <div
                    class="
                      flex flex-wrap-reverse
                      items-center
                      ml-6
                      cursor
                      mt-3
                      pl-6
                      pt-6
                    "
                    @click="cardDetails.rules.splice(index, 1)"
                  >
                    <MinusSquareIcon color="white" class="mt-3" />
                    <div class="addCardFont font-semibold ml-3 cursor mt-3">
                      Remove
                    </div>
                  </div>
                </vs-col>
              </vs-row>
              <vs-row
                v-bind:class="{ hidder: cardDetails.newRuleCheck == 'No' }"
              >
                <div
                  class="flex flex-wrap-reverse items-center ml-5 cursor"
                  @click="addNewRule"
                >
                  <PlusSquareIcon color="white" />
                  <h6 class="ml-2 mt-1 cursor">Add Rule</h6>
                </div>
              </vs-row>
            </vs-row>
          </vs-row>
        </tab-content>
        <modal
          :pointsCategoriesOption="pointsCategoriesOption"
          :showModal="showModal"
          :bonusindex="bonusIndex"
          :bonusCategory="BonusCategoryData"
          @close_modal_success="closeModalonSuccess"
          @close_modal_dismiss="closeModalonDismiss"
        ></modal>

        <pointCategorymodal
          :pointsCategoriesOption="pointsCategoriesOptionList"
          :showModal="showModal1"
          @close_modal_success="closeModalonSuccess1"
          @close_modal_dismiss="closeModalonDismiss1"
        ></pointCategorymodal>
      </form-wizard>
    </div>
    <vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="askPointCategoryRemove.success"
      >
        <div style="magine-bottom: 30px" class="mb-5">
          <h5>{{ askPointCategoryRemove.msg }}</h5>
        </div>

        <div
          style="text-align: center; margin-top: 30px"
          vs-type="flex"
          vs-justify="center"
        >
          <vs-button
            class="mt-11 mr-5"
            @click="removeNewPointCategory()"
            color="primary"
            type="filled"
            >Yes</vs-button
          >
          <vs-button
            class="mt-11 ml-5"
            @click="keepNewPointCategory()"
            color="primary"
            type="filled"
            >No</vs-button
          >
        </div>
      </vs-popup>
    </vs-row>
  </vs-row>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Vue from "vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  UploadCloudIcon,
  PlusSquareIcon,
  MinusSquareIcon,
  MenuIcon,
} from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import Datepicker from "vuejs-datepicker";
import draggable from "vuedraggable";
import EventBus from "@/event-bus.js";
import Editor from "@tinymce/tinymce-vue";
import VueLoadImage from "vue-load-image";
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";

import {
  validateIssuerName,
  validateUpgradeCard,
  validateCardName,
  validateProductChange,
  validateDowngradeCard,
  validateUploadPhoto,
  validateAnnualFee,
  validateNumeric,
  validateRules,
  validateFeeCategory,
  validateAlphaNumeric,
  validatePoints,
  validateGroupPoints,
  validatePointsNames,
  validatePerks,
  validateTargetedOffers,
} from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import Index from "../../accounts/index.vue";
import modal from "../../credit-cards/modal.vue";
import pointCategorymodal from "../../credit-cards/add-point-cateogry-modal.vue";

export default {
  data() {
    return {
      valuation: "",
      toggleColorList: false,

      calculatedFee: 0,
      cardDetails: {
        selectedIssuer: {
          name: "",
        },
        cardName: "",
        newRuleCheck: "No",
        cardType: "credit",
        annualFee: "",
        upgradeCard: "",
        productChange: "",
        downgradeCard: "",
        pointDescription: "",
        effectiveDescription: "",
        transactionFee: false,
        international_transaction_status: "no",
        five_twenty_four: true,
        photo: "",
        photo_array: [],
        fee_categories: [],
        rules: [],
        pointsCategories: [],
        perks: [],
        targeted_offers: [],
      },
      SubCategorypoints: {
        show: false,

        name: "",
        category: "",
        order: "",
        subcategory: [
          {
            order: {
              type: Number,
            },

            category: "",
          },
        ],
        removed_subcategory: [
          {
            order: {
              type: Number,
            },

            category: "",
          },
        ],
      },
      photoChangeFlag: false,
      previewPicture: [],
      removedSubcategories: [],
      perkslist: [],
      pointsCategoriesOption: [],
      dynamic_bonus_categoires: [],

      perks_key_date_option: [
        {
          name: "Enrollment Date",
          value: "enrollment_date",
        },
        {
          name: "Calendar Year",
          value: "calendar_year",
        },
        {
          name: "Custom Date",
          value: "custom_date",
        },
        {
          name: "Anniversary Date",
          value: "anniversary_date",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      earned_perks_key_date_option: [
        {
          name: "Enrollment Date",
          value: "enrollment_date",
        },
        {
          name: "Calendar Year",
          value: "calendar_year",
        },
        {
          name: "Custom Date",
          value: "custom_date",
        },
        {
          name: "Anniversary Date",
          value: "anniversary_date",
        },
        {
          name: "Earned Date",
          value: "earned_date",
        },
        {
          name: "Elite Year January",
          value: "elite_year_january",
        },
        {
          name: "Elite Year February",
          value: "elite_year_february",
        },
        {
          name: "Elite Year March",
          value: "elite_year_march",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      perks_date_type_option: [
        {
          name: "Expiration",
          value: "expiration",
        },
        {
          name: "Arrival",
          value: "arrival",
        },
        {
          name: "Deadline",
          value: "deadline",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      expiration_date_type_options: [
        {
          name: "Monthly",
          value: "monthly",
        },
        {
          name: "Custom Date",
          value: "custom_date",
        },
        {
          name: "Calendar Year",
          value: "calendar_year",
        },
        {
          name: "Anniversary Date",
          value: "anniversary_date",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],
      perks_call_to_action_options: [
        {
          name: "Track usage",
          value: "track_usage",
        },
        {
          name: "Track earned status",
          value: "track_earned_status",
        },
        {
          name: "Mark as received",
          value: "mark_as_received",
        },
        {
          name: "Mark as enrolled",
          value: "mark_as_enrolled",
        },
        {
          name: "Track earned tiers",
          value: "track_earned_tiers",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],
      earned_perks_call_to_action_options: [
        {
          name: "Track usage",
          value: "track_usage",
        },

        {
          name: "Mark as received",
          value: "mark_as_received",
        },
        {
          name: "Mark as enrolled",
          value: "mark_as_enrolled",
        },
        {
          name: "Track earned tiers",
          value: "track_earned_tiers",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      issuersList: [],

      cardsList: [],
      toggleCardsList: false,

      rulesList: [],

      pointCategoryAddSelector: "",

      pointCategoryAddIndex: "",
      pointCategoryAddGroupIndex: "",
      pointCategoryAddType: "",

      pointCategoryAddTargetindex: "",
      pointCategoryAddTargetBonusindex: "",
      pointCategoryAddTargetCategoryIndex: "",

      errors: {
        issuerName: {
          msg: "",
          success: false,
        },
        upgradeCard: {
          msg: "",
          success: false,
        },
        cardName: {
          msg: "",
          success: false,
        },
        productChange: {
          msg: "",
          success: false,
        },
        downgradeCard: {
          msg: "",
          success: false,
        },
        photo: {
          msg: "",
          success: false,
        },
        annualFee: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
        feeCategory: {
          msg: "",
          success: false,
        },
        pointCategories: {
          msg: "",
          success: false,
        },
        perks: {
          msg: "",
          success: false,
        },
        perks1: {
          msg: "",
          success: false,
        },
        subCategory: {
          msg: "",
          success: false,
        },
        targetedOffers: {
          msg: "",
          success: false,
        },
      },
      validateIssuerName,
      validateUpgradeCard,
      validateCardName,
      validateProductChange,
      validateDowngradeCard,
      validateUploadPhoto,
      validateAnnualFee,
      validateNumeric,
      validateRules,
      validateFeeCategory,
      validateAlphaNumeric,
      validatePoints,
      validateGroupPoints,
      validatePointsNames,
      validatePerks,
      validateTargetedOffers,

      modifiedList: [],

      genericErrorMessage,
      toast,
      showModal: false,
      showModal1: false,
      bonusIndex: "",
      currentModelStatus: "",
      tempbonusCategory: [],
      BonusCategoryData: [],
      pointsCategoriesOptionList: [],
      newlyCreatedPointCategories: [],
      groupCat: "",
      askPointCategoryRemove: {
        msg: "",
        success: false,
        cardPointCategoryIndex: "",
        cardPointCategoryGroupIndex: "",
        newPointCategoryIndex: "",
        removalType: "",
        cardTargetedOfferIndex: "",
        cardTargetedOfferBonusIndex: "",
        cardTargetedOfferCategoryIndex: "",
      },
    };
  },
  methods: {
    defaultImage(index) {
      // if (index > 0) {
      //   let tempcontainer = this.cardDetails.photo;
      //   this.cardDetails.photo = this.cardDetails.photo_array[index - 1];
      //   this.cardDetails.photo_array.splice(index - 1, 1);
      //   this.cardDetails.photo_array.push(tempcontainer);
      // }

      // let temp = this.previewPicture[index];
      // this.previewPicture.splice(index, 1);
      // this.previewPicture.unshift(temp);
      this.previewPicture.forEach((data) => {
        if (data.defaultImage) {
          data.defaultImage = false;
        }
      });
      this.previewPicture[index].defaultImage = true;
    },
    removeCardImage(picture, index) {
      if (index == 0) {
        if (this.cardDetails.photo_array.length > 0) {
          this.cardDetails.photo = "";
          this.previewPicture.splice(index, 1);
          this.cardDetails.photo = this.cardDetails.photo_array[0];
          this.cardDetails.photo_array.splice(0, 1);
        } else {
          this.cardDetails.photo = "";
          this.previewPicture.splice(index, 1);
        }
      } else {
        this.cardDetails.photo_array.splice(index - 1, 1);
        this.previewPicture.splice(index, 1);
      }
    },
    imageclicked(inp) {
      let image = {
        src: inp.toString(),
      };

      const $viewer = viewerApi({
        options: {
          toolbar: true,
          navbar: false,
          title: false,
          initialViewIndex: 0,
          zIndex: 99999,
        },
        images: [image],
      });
    },
    removeDynamicBonusCategories(index) {
      if (this.cardDetails.pointsCategories.length > 0) {
        this.cardDetails.pointsCategories.forEach((pointCat) => {
          if (
            pointCat.dynamic_bonus_category &&
            pointCat.dynamic_bonus_category.length > 0
          ) {
            pointCat.dynamic_bonus_category.splice(index, 1);
          }
          if (pointCat.groupCategories && pointCat.groupCategories.length > 0) {
            pointCat.groupCategories.forEach((groupCat) => {
              if (groupCat.dynamic_bonus_category.length > 0) {
                groupCat.dynamic_bonus_category.splice(index, 1);
              }
            });
          }
        });
      }
      if (this.cardDetails.targeted_offers.length > 0) {
        this.cardDetails.targeted_offers.forEach((targetedoffer) => {
          if (
            targetedoffer.bonusCategory &&
            targetedoffer.bonusCategory.length > 0
          ) {
            targetedoffer.bonusCategory.forEach((bonusCategory) => {
              if (
                bonusCategory &&
                bonusCategory.categories &&
                bonusCategory.categories.length > 0
              ) {
                bonusCategory.categories.forEach((t_bonuscat) => {
                  if (t_bonuscat.dynamic_bonus_category.length > 0) {
                    t_bonuscat.dynamic_bonus_category.splice(index, 1);
                  }
                });
              }
            });
          }
        });
      }
    },
    changeIsAdded(index, DynamicindexCat) {
      // console.log(
      //   "in before",
      //   this.cardDetails.pointsCategories[index].dynamic_bonus_category[
      //     DynamicindexCat
      //   ].isAdded
      // );
      // console.log(
      //   "in addeddddd",
      //   this.cardDetails.pointsCategories[index].dynamic_bonus_category[
      //     DynamicindexCat
      //   ].isAdded
      // );
    },
    addDynamicBonusCategory() {
      this.dynamic_bonus_categoires.push({
        limit: 0,
      });
      this.addAllDynamicCategoriesCheckboxes();
    },
    addAllDynamicCategoriesCheckboxes() {
      if (this.dynamic_bonus_categoires.length > 0) {
        this.dynamic_bonus_categoires.forEach((main, index) => {
          if (this.cardDetails.pointsCategories.length > 0) {
            this.cardDetails.pointsCategories.forEach((data) => {
              if (data.dynamic_bonus_category.length <= index) {
                data.dynamic_bonus_category.push({
                  isAdded: false,
                });
              }
              if (data.groupCategories && data.groupCategories.length > 0) {
                data.groupCategories.forEach((groupCat) => {
                  if (groupCat.dynamic_bonus_category.length <= index) {
                    groupCat.dynamic_bonus_category.push({
                      isAdded: false,
                    });
                  }
                });
              }
            });
          }
          if (this.cardDetails.targeted_offers.length > 0) {
            this.cardDetails.targeted_offers.forEach((targetedoffer) => {
              if (
                targetedoffer.bonusCategory &&
                targetedoffer.bonusCategory.length > 0
              ) {
                targetedoffer.bonusCategory.forEach((bonusCategory) => {
                  if (
                    bonusCategory &&
                    bonusCategory.categories &&
                    bonusCategory.categories.length > 0
                  ) {
                    bonusCategory.categories.forEach((t_bonuscat) => {
                      if (t_bonuscat.dynamic_bonus_category.length <= index) {
                        t_bonuscat.dynamic_bonus_category.push({
                          isAdded: false,
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    },
    removeGroupItem(index) {
      //console.log(this.cardDetails.pointsCategories[index]);
      if (
        this.cardDetails.pointsCategories[index].points_category &&
        this.cardDetails.pointsCategories[index].points_category.trim() != "" &&
        this.newlyCreatedPointCategories &&
        this.newlyCreatedPointCategories.length > 0
      ) {
        let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
          (a) =>
            a._id.toString() ==
            this.cardDetails.pointsCategories[index].points_category.toString()
        );
        if (ifNewPointCategory >= 0) {
          this.askPointCategoryRemove.msg =
            'Do you want to delete the newly created "' +
            this.newlyCreatedPointCategories[ifNewPointCategory].name +
            '" Point Category from database as well?';
          this.askPointCategoryRemove.success = true;
          this.askPointCategoryRemove.cardPointCategoryIndex = index;
          this.askPointCategoryRemove.newPointCategoryIndex =
            ifNewPointCategory;

          this.askPointCategoryRemove.removalType = "simple";
        } else {
          this.removeGroupedItemFirstIndex(index);
        }
      } else {
        this.removeGroupedItemFirstIndex(index);
      }
    },
    removeGroupedItemFirstIndex(index) {
      if (
        this.cardDetails.pointsCategories[index].groupCategories.length == 0
      ) {
        this.cardDetails.pointsCategories.splice(index, 1);
      } else {
        let tempCat =
          this.cardDetails.pointsCategories[index].groupCategories[0];
        this.cardDetails.pointsCategories[index].points_category =
          tempCat.points_category;
        this.cardDetails.pointsCategories[index].multiplier =
          tempCat.multiplier;
        this.cardDetails.pointsCategories[index].percentage =
          tempCat.percentage;

        this.cardDetails.pointsCategories[index].groupCategories.splice(0, 1);
      }
    },
    async addTargetedOfferCategory(index, Bonusindex) {
      if (
        (await this.hasTargetedOfferCategoryUniqueNames(
          this.cardDetails.targeted_offers[index].bonusCategory
        )) != true
      ) {
        this.errors.targetedOffers.msg = "Target Offer field must be unique";
        this.errors.targetedOffers.success = true;
        return;
      }

      await this.validateTargetedOffers(
        this.cardDetails.targeted_offers[index].bonusCategory,
        "targetedOffers"
      );
      let { targetedOffers } = this.errors;
      if (targetedOffers.success) {
        return false;
      }
      this.cardDetails.targeted_offers[index].bonusCategory[
        Bonusindex
      ].categories.push({
        points_category: "",
        percentage: "",
        multiplier: 0,
        dynamic_bonus_category: [],
      });
      this.addAllDynamicCategoriesCheckboxes();
    },
    removeTargetedOfferCategory(index, Bonusindex, categoryIndex) {
      if (
        this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
          .categories.length > 1
      ) {
        if (
          this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
            .categories[categoryIndex].points_category &&
          this.cardDetails.targeted_offers[index].bonusCategory[
            Bonusindex
          ].categories[categoryIndex].points_category.trim() != "" &&
          this.newlyCreatedPointCategories &&
          this.newlyCreatedPointCategories.length > 0
        ) {
          let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
            (a) =>
              a._id.toString() ==
              this.cardDetails.targeted_offers[index].bonusCategory[
                Bonusindex
              ].categories[categoryIndex].points_category.toString()
          );
          if (ifNewPointCategory >= 0) {
            this.askPointCategoryRemove.msg =
              'Do you want to delete the newly created "' +
              this.newlyCreatedPointCategories[ifNewPointCategory].name +
              '" Point Category from database as well?';
            this.askPointCategoryRemove.success = true;

            this.askPointCategoryRemove.cardTargetedOfferIndex = index;
            this.askPointCategoryRemove.cardTargetedOfferBonusIndex =
              Bonusindex;
            this.askPointCategoryRemove.cardTargetedOfferCategoryIndex =
              categoryIndex;

            this.askPointCategoryRemove.newPointCategoryIndex =
              ifNewPointCategory;
            this.askPointCategoryRemove.removalType = "targeted_group";
          } else {
            this.cardDetails.targeted_offers[index].bonusCategory[
              Bonusindex
            ].categories.splice(categoryIndex, 1);
          }
        } else {
          this.cardDetails.targeted_offers[index].bonusCategory[
            Bonusindex
          ].categories.splice(categoryIndex, 1);
        }
      } else if (
        this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
          .categories.length == 1
      ) {
        if (
          this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
            .categories[0].points_category &&
          this.cardDetails.targeted_offers[index].bonusCategory[
            Bonusindex
          ].categories[0].points_category.trim() != "" &&
          this.newlyCreatedPointCategories &&
          this.newlyCreatedPointCategories.length > 0
        ) {
          let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
            (a) =>
              a._id.toString() ==
              this.cardDetails.targeted_offers[index].bonusCategory[
                Bonusindex
              ].categories[0].points_category.toString()
          );
          if (ifNewPointCategory >= 0) {
            this.askPointCategoryRemove.msg =
              'Do you want to delete the newly created "' +
              this.newlyCreatedPointCategories[ifNewPointCategory].name +
              '" Point Category from database as well?';
            this.askPointCategoryRemove.success = true;
            this.askPointCategoryRemove.cardTargetedOfferIndex = index;
            this.askPointCategoryRemove.cardTargetedOfferBonusIndex =
              Bonusindex;
            this.askPointCategoryRemove.newPointCategoryIndex =
              ifNewPointCategory;
            this.askPointCategoryRemove.removalType = "targeted_single";
          } else {
            this.cardDetails.targeted_offers[index].bonusCategory.splice(
              Bonusindex,
              1
            );
          }
        } else {
          this.cardDetails.targeted_offers[index].bonusCategory.splice(
            Bonusindex,
            1
          );
        }
        // console.log(
        //   "2",
        //   this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
        // );
      }
    },
    targetedofferchangehandler(inp) {
      this.updateAllTargetedlimitCategories();
    },
    validateMainTargetedOffer() {
      if (this.cardDetails.targeted_offers.length > 0) {
        let check = 0;
        this.cardDetails.targeted_offers.forEach((data) => {
          if (data.bonusCategory && data.bonusCategory.length == 0) {
            check = 1;
            return false;
          }
        });
        if (check == 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    updateAllTargetedlimitCategories() {
      for (var i = 0; i < this.cardDetails.targeted_offers.length; i++) {
        if (this.cardDetails.targeted_offers[i].manage_spend_limit == true) {
          if (
            this.cardDetails.targeted_offers[i].manage_spend_limit_options
              .apply_spend_limit_to_other_categories == "true"
          ) {
            this.handleTargetCategoryinLimit(i);
          }
        }
      }
    },
    async validateGroupCategories(index) {
      if (
        this.cardDetails.pointsCategories[index].points_category.toString() !=
        this.groupCat._id.toString()
      ) {
        let temp = this.cardDetails.pointsCategories[
          index
        ].groupCategories.find((a) => a.points_category == this.groupCat._id);
        if (!temp) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async AddCategoryToGroupHandler(index) {
      if ((await this.validateGroupCategories(index)) != true) {
        this.errors.pointCategories.msg =
          "Group Categories field must be unique";
        this.errors.pointCategories.success = true;
        return;
      }
      if (this.errors.pointCategories.success == true) {
        this.errors.pointCategories.success = false;
        this.errors.pointCategories.msg = "";
      }
      // console.log(this.groupCat);
      this.cardDetails.pointsCategories[index].groupCategories.push({
        points_category: this.groupCat._id,
        name: this.groupCat.name,
        category_in_limit: false,
      });
      this.addAllDynamicCategoriesCheckboxes();
      //console.log(this.cardDetails.pointsCategories[index].groupCategories);
    },
    changeSpendLimitOption(index, Ctype) {
      this.cardDetails.pointsCategories[index].type = Ctype;
    },
    // handleCategoryinLimit(index) {
    //   for (var ind = 0; ind < this.cardDetails.pointsCategories.length; ind++) {
    //     let tempobj = this.cardDetails.pointsCategories[
    //       index
    //     ].groupCategories.findIndex(
    //       (b) =>
    //         b.category.replace(/\s+/g, " ") ==
    //         this.cardDetails.pointsCategories[ind].points_category.replace(
    //           /\s+/g,
    //           " "
    //         )
    //     );

    //     if (tempobj >= 0) {
    //       if (
    //         this.cardDetails.pointsCategories[ind].points_category !=
    //         this.cardDetails.pointsCategories[index]
    //           .groupCategories[tempobj].category
    //       ) {
    //         this.cardDetails.pointsCategories[
    //           index
    //         ].groupCategories[tempobj] =
    //           this.cardDetails.pointsCategories[ind].points_category;
    //       }
    //     } else {
    //       this.cardDetails.pointsCategories[
    //         index
    //       ].groupCategories.push({
    //         category: this.cardDetails.pointsCategories[
    //           ind
    //         ].points_category.replace(/\s+/g, " "),
    //         category_in_limit: false,
    //         name: this.pointsCategoriesOption.find(
    //           (abb) =>
    //             abb._id ==
    //             this.cardDetails.pointsCategories[ind].points_category.replace(
    //               /\s+/g,
    //               " "
    //             )
    //         ).name,
    //       });
    //     }
    //   }

    //   if (
    //     this.cardDetails.pointsCategories[index]
    //       .groupCategories.length != this.cardDetails.pointsCategories.length
    //   ) {
    //     let allindexes = [];
    //     for (
    //       var i = 0;
    //       i <
    //       this.cardDetails.pointsCategories[index]
    //         .groupCategories.length;
    //       i++
    //     ) {
    //       let tt = this.cardDetails.pointsCategories.find(
    //         (bb) =>
    //           bb.points_category ==
    //           this.cardDetails.pointsCategories[index]
    //             .groupCategories[i].category
    //       );
    //       if (!tt) {
    //         allindexes.push(i);
    //       }
    //     }
    //     allindexes.forEach((ab) => {
    //       this.cardDetails.pointsCategories[
    //         index
    //       ].groupCategories.splice(ab, 1);
    //     });
    //   }
    //   let finremove = this.cardDetails.pointsCategories[
    //     index
    //   ].groupCategories.findIndex(
    //     (a) =>
    //       a.category == this.cardDetails.pointsCategories[index].points_category
    //   );
    //   if (finremove >= 0) {
    //     this.cardDetails.pointsCategories[
    //       index
    //     ].groupCategories.splice(finremove, 1);
    //   }
    // },
    // updateAlllimitCategories() {
    //   for (var i = 0; i < this.cardDetails.pointsCategories.length; i++) {
    //     if (this.cardDetails.pointsCategories[i].manage_spend_limit == true) {
    //       if (
    //         this.cardDetails.pointsCategories[i].manage_spend_limit_options
    //           .apply_spend_limit_to_other_categories == "true"
    //       ) {
    //         this.handleCategoryinLimit(i);
    //       }
    //     }
    //   }
    // },

    SetCategoriesDate(category, inp, inp2, index) {
      if (inp == "calendar_year") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(0, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(11, 31);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q1") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(0, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(2, 31);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q2") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(3, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(5, 30);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q3") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(6, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(8, 30);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q4") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(9, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(11, 31);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "anniversary_year") {
        // category.beginningDate = new Date();
        // category.beginningDate.setHours(0, 0, 0);
        category.beginningDate = "";
        category.endDate = "";
      } else if (inp == "recurring_monthly") {
        category.beginningDate = "";
        category.endDate = "";
        // var today = new Date();
        // var lastDayOfMonth = new Date(
        //   today.getFullYear(),
        //   today.getMonth() + 1,
        //   0
        // );
      } else if (inp == "recurring_quarters") {
        category.beginningDate = "";
        category.endDate = "";
      }
    },

    showBonusCategoryModel(index, inp) {
      this.bonusIndex = index;
      this.currentModelStatus = inp;
      if (inp == "fee") {
        this.BonusCategoryData = this.cardDetails.fee_categories;
        this.tempbonusCategory =
          this.cardDetails.fee_categories[index].bonus_categories.slice();
      } else if (inp == "perks") {
        this.BonusCategoryData = this.cardDetails.perks;
        this.tempbonusCategory =
          this.cardDetails.perks[index].bonus_categories.slice();
      }
      this.showModal = true;
    },
    showPointCategryModal(categoryType, index, index2) {
      this.pointCategoryAddIndex = index;
      this.pointCategoryAddGroupIndex = index2;
      this.pointCategoryAddType = categoryType;
      this.pointsCategoriesOptionList = this.pointsCategoriesOption;
      this.pointCategoryAddSelector = "pointDetails";
      this.showModal1 = true;
    },
    showPointCategryModalForTargetedOffer(index, Bonusindex, categoryIndex) {
      this.pointCategoryAddTargetindex = index;
      this.pointCategoryAddTargetBonusindex = Bonusindex;
      this.pointCategoryAddTargetCategoryIndex = categoryIndex;
      this.pointCategoryAddSelector = "targetedOffer";
      this.showModal1 = true;
    },
    closeModalonSuccess() {
      this.showModal = false;
    },
    closeModalonDismiss() {
      if (this.currentModelStatus == "fee") {
        this.cardDetails.fee_categories[this.bonusIndex].bonus_categories =
          this.tempbonusCategory;
      } else if (this.currentModelStatus == "perks") {
        this.cardDetails.perks[this.bonusIndex].bonus_categories =
          this.tempbonusCategory;
      }
      this.showModal = false;
    },
    closeModalonSuccess1(pointsCategorylist, newpointscategoryName) {
      this.showModal1 = false;
      this.pointsCategoriesOption = pointsCategorylist;
      let tempCategoryIndex = this.pointsCategoriesOption.findIndex(
        (a) => a.name && a.name.toString() == newpointscategoryName.toString()
      );
      if (tempCategoryIndex >= 0) {
        this.newlyCreatedPointCategories.push(
          this.pointsCategoriesOption[tempCategoryIndex]
        );
        if (this.pointCategoryAddSelector == "pointDetails") {
          if (this.pointCategoryAddType == "single") {
            this.cardDetails.pointsCategories[
              this.pointCategoryAddIndex
            ].points_category =
              this.pointsCategoriesOption[tempCategoryIndex]._id;
            this.categorychangeHandler(this.pointCategoryAddIndex);
          } else if (this.pointCategoryAddType == "group") {
            this.cardDetails.pointsCategories[
              this.pointCategoryAddIndex
            ].groupCategories[this.pointCategoryAddGroupIndex].points_category =
              this.pointsCategoriesOption[tempCategoryIndex]._id;
          }
        } else if ((this.pointCategoryAddSelector = "targetedOffer")) {
          this.cardDetails.targeted_offers[
            this.pointCategoryAddTargetindex
          ].bonusCategory[this.pointCategoryAddTargetBonusindex].categories[
            this.pointCategoryAddTargetCategoryIndex
          ].points_category =
            this.pointsCategoriesOption[tempCategoryIndex]._id;
          this.targetedofferchangehandler(
            this.pointCategoryAddTargetBonusindex
          );
        }
      }
    },
    removeSingleitemPointCategory(index) {
      //console.log(this.cardDetails.pointsCategories[index]);
      if (
        this.cardDetails.pointsCategories[index].points_category &&
        this.cardDetails.pointsCategories[index].points_category.trim() != "" &&
        this.newlyCreatedPointCategories &&
        this.newlyCreatedPointCategories.length > 0
      ) {
        let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
          (a) =>
            a._id.toString() ==
            this.cardDetails.pointsCategories[index].points_category.toString()
        );
        if (ifNewPointCategory >= 0) {
          this.askPointCategoryRemove.msg =
            'Do you want to delete the newly created "' +
            this.newlyCreatedPointCategories[ifNewPointCategory].name +
            '" Point Category from database as well?';
          this.askPointCategoryRemove.success = true;
          this.askPointCategoryRemove.cardPointCategoryIndex = index;
          this.askPointCategoryRemove.newPointCategoryIndex =
            ifNewPointCategory;
          this.askPointCategoryRemove.removalType = "simple";
        } else {
          this.cardDetails.pointsCategories.splice(index, 1);
        }
      } else {
        this.cardDetails.pointsCategories.splice(index, 1);
      }
    },
    removeNewPointCategory() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$ApiKeys.BASE_URL + this.$EndPoints.UpdateCategories,
            {
              remove_categories: [
                this.newlyCreatedPointCategories[
                  this.askPointCategoryRemove.newPointCategoryIndex
                ]._id,
              ],
              isAdded: false,
            },
            {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            }
          )
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.updateStatus = {
                msg: res.data.data,
                status: true,
              };
              //resolve(this.getCategories());
              let orignalPointIndex = this.pointsCategoriesOption.findIndex(
                (a) =>
                  a._id.toString() ==
                  this.newlyCreatedPointCategories[
                    this.askPointCategoryRemove.newPointCategoryIndex
                  ]._id.toString()
              );
              if (orignalPointIndex >= 0) {
                this.pointsCategoriesOption.splice(orignalPointIndex, 1);
              }
              this.newlyCreatedPointCategories.splice(
                this.askPointCategoryRemove.newPointCategoryIndex,
                1
              );
              // this.cardDetails.pointsCategories.splice(
              //   this.askPointCategoryRemove.cardPointCategoryIndex,
              //   1
              // );
              if (this.askPointCategoryRemove.removalType == "simple") {
                this.removeGroupedItemFirstIndex(
                  this.askPointCategoryRemove.cardPointCategoryIndex
                );
              } else if (this.askPointCategoryRemove.removalType == "group") {
                this.cardDetails.pointsCategories[
                  this.askPointCategoryRemove.cardPointCategoryIndex
                ].groupCategories.splice(
                  this.askPointCategoryRemove.cardPointCategoryGroupIndex,
                  1
                );
              } else if (
                this.askPointCategoryRemove.removalType == "targeted_group"
              ) {
                this.cardDetails.targeted_offers[
                  this.askPointCategoryRemove.cardTargetedOfferIndex
                ].bonusCategory[
                  this.askPointCategoryRemove.cardTargetedOfferBonusIndex
                ].categories.splice(
                  this.askPointCategoryRemove.cardTargetedOfferCategoryIndex,
                  1
                );
              } else if (
                this.askPointCategoryRemove.removalType == "targeted_single"
              ) {
                this.cardDetails.targeted_offers[
                  this.askPointCategoryRemove.cardTargetedOfferIndex
                ].bonusCategory.splice(
                  this.askPointCategoryRemove.cardTargetedOfferBonusIndex,
                  1
                );
              }

              this.askPointCategoryRemove.success = false;
              this.askPointCategoryRemove.cardPointCategoryIndex = "";
              this.askPointCategoryRemove.newPointCategoryIndex = "";
              this.askPointCategoryRemove.cardPointCategoryGroupIndex = "";
              this.askPointCategoryRemove.removalType = "";
              this.askPointCategoryRemove.cardTargetedOfferIndex = "";
              this.askPointCategoryRemove.cardTargetedOfferBonusIndex = "";
              this.askPointCategoryRemove.cardTargetedOfferCategoryIndex = "";
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.toast(this.genericErrorMessage());

            this.$vs.loading.close();
            // console.log("Error in updateCategories: ",e);
          });
      });
    },
    keepNewPointCategory() {
      // this.cardDetails.pointsCategories.splice(
      //   this.askPointCategoryRemove.cardPointCategoryIndex,
      //   1
      // );
      if (this.askPointCategoryRemove.removalType == "simple") {
        this.removeGroupedItemFirstIndex(
          this.askPointCategoryRemove.cardPointCategoryIndex
        );
      } else if (this.askPointCategoryRemove.removalType == "group") {
        this.cardDetails.pointsCategories[
          this.askPointCategoryRemove.cardPointCategoryIndex
        ].groupCategories.splice(
          this.askPointCategoryRemove.cardPointCategoryGroupIndex,
          1
        );
      } else if (this.askPointCategoryRemove.removalType == "targeted_group") {
        this.cardDetails.targeted_offers[
          this.askPointCategoryRemove.cardTargetedOfferIndex
        ].bonusCategory[
          this.askPointCategoryRemove.cardTargetedOfferBonusIndex
        ].categories.splice(
          this.askPointCategoryRemove.cardTargetedOfferCategoryIndex,
          1
        );
      } else if (this.askPointCategoryRemove.removalType == "targeted_single") {
        this.cardDetails.targeted_offers[
          this.askPointCategoryRemove.cardTargetedOfferIndex
        ].bonusCategory.splice(
          this.askPointCategoryRemove.cardTargetedOfferBonusIndex,
          1
        );
      }

      this.askPointCategoryRemove.success = false;
      this.askPointCategoryRemove.cardPointCategoryIndex = "";
      this.askPointCategoryRemove.newPointCategoryIndex = "";
      this.askPointCategoryRemove.cardPointCategoryGroupIndex = "";
      this.askPointCategoryRemove.removalType = "";
      this.askPointCategoryRemove.cardTargetedOfferIndex = "";
      this.askPointCategoryRemove.cardTargetedOfferBonusIndex = "";
      this.askPointCategoryRemove.cardTargetedOfferCategoryIndex = "";
    },

    removeGroupPointsCategory(index, Groupindex) {
      if (
        this.cardDetails.pointsCategories[index].groupCategories[Groupindex]
          .points_category &&
        this.cardDetails.pointsCategories[index].groupCategories[
          Groupindex
        ].points_category.trim() != "" &&
        this.newlyCreatedPointCategories &&
        this.newlyCreatedPointCategories.length > 0
      ) {
        let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
          (a) =>
            a._id.toString() ==
            this.cardDetails.pointsCategories[index].groupCategories[
              Groupindex
            ].points_category.toString()
        );
        if (ifNewPointCategory >= 0) {
          this.askPointCategoryRemove.msg =
            'Do you want to delete the newly created "' +
            this.newlyCreatedPointCategories[ifNewPointCategory].name +
            '" Point Category from database as well?';
          this.askPointCategoryRemove.success = true;
          this.askPointCategoryRemove.cardPointCategoryIndex = index;
          this.askPointCategoryRemove.cardPointCategoryGroupIndex = Groupindex;
          this.askPointCategoryRemove.newPointCategoryIndex =
            ifNewPointCategory;
          this.askPointCategoryRemove.removalType = "group";
        } else {
          this.cardDetails.pointsCategories[index].groupCategories.splice(
            Groupindex,
            1
          );
        }
      } else {
        this.cardDetails.pointsCategories[index].groupCategories.splice(
          Groupindex,
          1
        );
      }
    },

    closeModalonDismiss1() {
      this.showModal1 = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 200,
        behavior: "smooth",
      });
    },
    scrollToTop2() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollToMid() {
      window.scrollTo({
        top: 650,
        behavior: "smooth",
      });
    },

    AddnewPerkhandler(index) {
      if (this.cardDetails.perks[index].earned_status.add_new_perk) {
        if (
          this.cardDetails.perks[index].earned_status.earned_perk_token &&
          this.cardDetails.perks[index].earned_status.earned_perk_token != ""
        ) {
          let temp1 = this.cardDetails.perks.findIndex(
            (a) =>
              a.token ==
              this.cardDetails.perks[index].earned_status.earned_perk_token
          );
          if (temp1 >= 0) {
            this.cardDetails.perks[temp1].disable = true;
          }
        }
      } else {
        if (
          this.cardDetails.perks[index].earned_status.earned_perk_token &&
          this.cardDetails.perks[index].earned_status.earned_perk_token != ""
        ) {
          let temp1 = this.cardDetails.perks.findIndex(
            (a) =>
              a.token ==
              this.cardDetails.perks[index].earned_status.earned_perk_token
          );
          if (temp1 >= 0) {
            this.cardDetails.perks[temp1].disable = false;
          }
        }
      }
    },
    removePerk(index) {
      if (
        this.cardDetails.perks[index].token &&
        this.cardDetails.perks[index].token != ""
      ) {
        let tempInd = this.cardDetails.perks.findIndex(
          (a) =>
            a.earned_status.earned_perk_token ==
            this.cardDetails.perks[index].token
        );
        if (tempInd >= 0) {
          this.cardDetails.perks[tempInd].earned_status.earned_perk_token = "";
          this.cardDetails.perks[tempInd].earned_status.add_new_perk = false;
        }
      } else if (
        this.cardDetails.perks[index].earned_status.earned_perk_token &&
        this.cardDetails.perks[index].earned_status.earned_perk_token != ""
      ) {
        let temp1 = this.cardDetails.perks.findIndex(
          (a) =>
            a.token ==
            this.cardDetails.perks[index].earned_status.earned_perk_token
        );
        if (temp1 >= 0) {
          this.cardDetails.perks.splice(temp1, 1);
        }
      }
      this.cardDetails.perks.splice(index, 1);
    },

    async validateinput(inp) {
      await this.validatePerks(inp, "perks");
      let { perks } = this.errors;
    },
    CallToActionButton(index) {
      if (
        this.cardDetails.perks[index].call_to_action == "track_earned_status" &&
        this.cardDetails.perks[index].earned_status.earned_perk_token == ""
      ) {
        this.addEarnedPerk(index);
      } else if (
        this.cardDetails.perks[index].call_to_action == "track_earned_status" &&
        this.cardDetails.perks[index].earned_status.earned_perk_token != ""
      ) {
        let tempVAR = this.cardDetails.perks.findIndex(
          (a) =>
            a.token ==
            this.cardDetails.perks[index].earned_status.earned_perk_token
        );
        if (tempVAR >= 0) {
          this.cardDetails.perks[tempVAR].show = true;
        }
      } else if (
        this.cardDetails.perks[index].call_to_action != "track_earned_status" &&
        this.cardDetails.perks[index].earned_status.earned_perk_token != ""
      ) {
        let tempVAR = this.cardDetails.perks.findIndex(
          (a) =>
            a.token ==
            this.cardDetails.perks[index].earned_status.earned_perk_token
        );
        if (tempVAR >= 0) {
          this.cardDetails.perks[tempVAR].show = false;
        }
      }
    },
    updateInternationalTransaction(value) {
      this.this.cardDetails.international_transaction_status = value;
    },
    addCreditCustomDate(index) {
      if (this.cardDetails.fee_categories[index].custom_dates) {
        this.cardDetails.fee_categories[index].custom_dates.push("");
      } else {
        this.cardDetails.fee_categories[index].custom_dates = [""];
      }
    },
    onChangeCreditExpiry(e, index) {
      let temp = this.cardDetails.fee_categories[index];
      temp.expiration_date_addition = {
        weeks:
          this.cardDetails.fee_categories[index].expiration_date_addition.weeks,
        months:
          this.cardDetails.fee_categories[index].expiration_date_addition
            .months,
        years:
          this.cardDetails.fee_categories[index].expiration_date_addition.years,
      };
      Vue.set(this.cardDetails.fee_categories, index, temp);
    },
    setCreditCutoffNA(index) {
      if (
        this.cardDetails.fee_categories &&
        this.cardDetails.fee_categories[index]
      ) {
        let temp = this.cardDetails.fee_categories[index];
        temp.na_cutoff = !this.cardDetails.fee_categories[index].na_cutoff;
        Vue.set(this.cardDetails.fee_categories, index, temp);
      }
    },
    setPerkEstimatedNA(index) {
      if (this.cardDetails.perks && this.cardDetails.perks[index]) {
        let temp = this.cardDetails.perks[index];
        temp.na_estimated_val = !this.cardDetails.perks[index].na_estimated_val;
        Vue.set(this.cardDetails.perks, index, temp);
      }
    },
    setPerkDisplay(index) {
      if (this.cardDetails.perks && this.cardDetails.perks[index]) {
        this.cardDetails.perks[index].hide_on_dashboard =
          !this.cardDetails.perks[index].hide_on_dashboard;
      }
    },
    setPerkExpiration(index) {
      if (this.cardDetails.perks && this.cardDetails.perks[index]) {
        this.cardDetails.perks[index].no_first_year_expiration =
          !this.cardDetails.perks[index].no_first_year_expiration;
      }
    },
    onKeyDateChanged(val, index) {
      if (val == "NA") {
        this.cardDetails.perks[index].date_type = "NA";
      }
    },
    calculatePercentages() {
      this.cardDetails.pointsCategories.forEach((value, index) => {
        if (value.multiplier > 0) {
          this.cardDetails.pointsCategories[index].percentage =
            value.multiplier * this.valuation;
        } else {
          this.cardDetails.pointsCategories[index].percentage = "";
        }
      });
    },

    async addPointCategory(categoryType) {
      if (this.cardDetails.pointsCategories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.cardDetails.pointsCategories,
            "single"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }

        if (
          (await this.hasCategoryUniqueNamesGroup(
            this.cardDetails.pointsCategories,
            "group"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories Group field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }
      }

      await this.validatePointsNames(
        this.cardDetails.pointsCategories,
        "pointCategories"
      );
      await this.validatePoints(
        this.cardDetails.pointsCategories,
        "pointCategories"
      );
      let { pointCategories } = this.errors;
      if (pointCategories.success) {
        return false;
      }

      await this.cardDetails.pointsCategories.push({
        points_category: "",
        percentage: "",
        multiplier: 0,
        parentCategoryId: "",
        useredit: false,
        subCategories: [
          {
            order: {
              type: Number,
            },

            category: "",
          },
        ],
        removed_subCategories: [
          {
            category: "",
          },
        ],
        dynamic_bonus_category: [],
        manage_spend_limit: false,
        groupCategories: [],
        type: categoryType,
        manage_spend_limit_options: {
          spend_limit: 0,
          points_limit: 0,
          beginningDate: "",
          endDate: "",
          date_type: "",
          apply_spend_limit_to_other_categories: false,
        },
        creator_offset: new Date().getTimezoneOffset(),
      });
      this.addAllDynamicCategoriesCheckboxes();
    },

    async addPointCategoryGroupCategory(index) {
      if (
        (await this.hasCategoryUniqueNamesGroup(
          this.cardDetails.pointsCategories,
          "group"
        )) != true
      ) {
        this.errors.pointCategories.msg =
          "Point Categories Group field must be unique";
        this.errors.pointCategories.success = true;
        return;
      }
      await this.validateGroupPoints(
        this.cardDetails.pointsCategories,
        "pointCategories"
      );
      let { pointCategories } = this.errors;
      if (pointCategories.success) {
        return false;
      }

      this.cardDetails.pointsCategories[index].groupCategories.push({
        points_category: "",
        percentage: "",
        multiplier: 0,
        dynamic_bonus_category: [],
      });
      this.addAllDynamicCategoriesCheckboxes();
    },

    async addTargetedOfferBonusCategory(index, inpType) {
      if (this.cardDetails.targeted_offers.length > 0) {
        if (
          (await this.hasTargetedOfferCategoryUniqueNames(
            this.cardDetails.targeted_offers[index].bonusCategory
          )) != true
        ) {
          this.errors.targetedOffers.msg = "Target Offer field must be unique";
          this.errors.targetedOffers.success = true;
          return;
        }

        await this.validateTargetedOffers(
          this.cardDetails.targeted_offers[index].bonusCategory,
          "targetedOffers"
        );
        let { targetedOffers } = this.errors;
        if (targetedOffers.success) {
          return false;
        }
        this.cardDetails.targeted_offers[index].bonusCategory.push({
          categories: [
            {
              points_category: "",
              percentage: "",
              multiplier: 0,
              dynamic_bonus_category: [],
            },
          ],
          manage_spend_limit: false,
          manage_spend_limit_options: {
            spend_limit: "",
            points_limit: 0,
            beginningDate: "",
            endDate: "",
            date_type: "",
            // apply_spend_limit_to_other_categories: false,
            // categories_in_limit: [
            //   {
            //     category: "",
            //     name: "",
            //     category_in_limit: false,
            //   },
            // ],
          },
          category_type: inpType,
          creator_offset: new Date().getTimezoneOffset(),
        });
        this.addAllDynamicCategoriesCheckboxes();
      }
    },

    async addMainTargetedOffer() {
      if ((await this.validateMainTargetedOffer()) != true) {
        this.errors.targetedOffers.msg =
          "Targeted Offers field cannot be empty";
        this.errors.targetedOffers.success = true;
        return;
      }
      this.cardDetails.targeted_offers.push({
        bonusCategory: [],
      });
    },

    async finalTargetedValidation(index) {
      let check = 0;
      if (
        (await this.hasTargetedOfferCategoryUniqueNames(
          this.cardDetails.targeted_offers[index].bonusCategory
        )) != true
      ) {
        this.errors.targetedOffers.msg = "Target Offer field must be unique";
        this.errors.targetedOffers.success = true;
        check = 1;
        //return false;
      }
      if (check == 0) {
        await this.validateTargetedOffers(
          this.cardDetails.targeted_offers[index].bonusCategory,
          "targetedOffers"
        );
        let { targetedOffers } = this.errors;
        if (targetedOffers.success) {
          check = 1;
          //return false;
        }
      }
      if (check == 1) {
        return false;
      } else {
        return true;
      }
    },
    addNewCredit() {
      this.cardDetails.fee_categories.push({
        credit_title: "",
        amount: 0,
        description: "",
        per_use_amount: 0,
        na_cutoff: false,
        cutoff_date: "",
        expiration_date_type: "NA",
        custom_dates: [""],
        expiration_date_addition: {
          weeks: 0,
          months: 0,
          years: 0,
        },
        bonus_categories: [],
      });
    },
    async addPerk() {
      await this.cardDetails.perks.push({
        category: "",
        description: "",
        estimated_value: "",
        na_estimated_val: false,
        key_date: "NA",
        date_type: "NA",
        custom_dates: [""],
        hide_on_dashboard: false,
        no_first_year_expiration: false,
        key_date_addition: {
          weeks: 0,
          months: 0,
          years: 0,
        },
        call_to_action: "NA",

        track_usage: {
          option_value: "",
          multiple_use_limit: 0,
        },
        mark_as_enrolled: {
          option_value: "",
          master_cutoff_date: "",
          track_usage_type: "",
          multiple_use_limit: 0,
        },
        track_earned_tiers: {
          option_value: "",
          input_text: "",
          number_of_limit: 0,
        },
        earned_status: {
          earned_perk_token: "",
          add_new_perk: false,
        },
        show: true,
        bonus_categories: [],
      });
    },
    generate_token(length) {
      //edit the token allowed characters
      var a =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(
          ""
        );
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      return b.join("");
    },
    async addEarnedPerk(index) {
      var tempPerk = [];
      if (this.cardDetails.perks[index].earned_status.earned_perk_token == "") {
        let temp = this.generate_token(14);
        this.cardDetails.perks[index].earned_status.earned_perk_token = temp;
        if (this.cardDetails.perks.length - index == 1) {
          await this.cardDetails.perks.push({
            token: temp,
            category: "",
            description: "",
            estimated_value: "",
            na_estimated_val: false,
            key_date: "NA",
            date_type: "NA",
            custom_dates: [""],
            hide_on_dashboard: false,
            no_first_year_expiration: false,
            key_date_addition: {
              weeks: 0,
              months: 0,
              years: 0,
            },

            call_to_action: "NA",

            track_usage: {
              option_value: "",
              multiple_use_limit: 0,
            },
            mark_as_enrolled: {
              option_value: "",
              master_cutoff_date: "",
              track_usage_type: "",
              multiple_use_limit: 0,
            },
            track_earned_tiers: {
              option_value: "",
              input_text: "",
              number_of_limit: 0,
            },
            earned_status: {
              earned_perk_token: "",
              add_new_perk: false,
            },
            show: true,
            disable: false,
            bonus_categories: [],
          });
        } else {
          await this.cardDetails.perks.splice(index + 1, 0, {
            token: temp,
            category: "",
            description: "",
            estimated_value: "",
            na_estimated_val: false,
            key_date: "NA",
            date_type: "NA",
            custom_dates: [""],
            hide_on_dashboard: false,
            no_first_year_expiration: false,
            key_date_addition: {
              weeks: 0,
              months: 0,
              years: 0,
            },

            call_to_action: "NA",

            track_usage: {
              option_value: "",
              multiple_use_limit: 0,
            },
            mark_as_enrolled: {
              option_value: "",
              master_cutoff_date: "",
              track_usage_type: "",
              multiple_use_limit: 0,
            },
            track_earned_tiers: {
              option_value: "",
              input_text: "",
              number_of_limit: 0,
            },
            earned_status: {
              earned_perk_token: "",
              add_new_perk: false,
            },
            show: true,
            disable: false,
            bonus_categories: [],
          });
        }
        tempPerk.push();
      }
    },
    calculateRulesWidth() {
      this.modifiedList = [];
      let maxLength = 80;
      for (var i = 0; i < this.rulesList.length; i++) {
        this.modifiedList[i] = {
          rule: "",
          _id: "",
        };
        if (this.rulesList[i].rule.length > maxLength) {
          this.modifiedList[i] = {
            rule: this.rulesList[i].rule.substr(0, maxLength) + "...",
            _id: this.rulesList[i]._id,
          };
        } else {
          this.modifiedList[i] = {
            rule: this.rulesList[i].rule,
            _id: this.rulesList[i]._id,
          };
        }
      }
    },
    handleCardFilter(id) {
      this.toggleCardsList = true;
      // console.log('product change: ',this.cardDetails.productChange)
    },
    closeCardsList() {
      this.toggleCardsList = false;
    },
    closeColorList() {
      if (this.toggleColorList) {
        this.toggleColorList = false;
        if (this.cardDetails.selectedIssuer.name) {
          this.errors.issuerName = {
            msg: "",
            success: false,
          };
        }
        this.getCardsList();
        this.getRules();
      }
    },

    async beforeFirstTabChange() {
      await this.validateIssuerName(this.cardDetails.selectedIssuer.name);
      await this.validateCardName(this.cardDetails.cardName);
      if (!this.errors.photo.success) {
        await this.validateUploadPhoto(this.cardDetails.photo);
      }
      let { issuerName, cardName, photo } = this.errors;
      if (issuerName.success || cardName.success || photo.success) {
        return false;
      }
      this.errors.rules = {
        msg: "",
        success: false,
      };
      return true;
    },
    async beforeSecondTabChange() {
      await this.validateAnnualFee(this.cardDetails.annualFee);
      await this.validateFeeCategory(this.cardDetails.fee_categories);
      let { annualFee, feeCategory } = this.errors;
      if (annualFee.success || feeCategory.success) {
        this.scrollToTop();
        return false;
      }
      return true;
    },
    async beforeThirdTabChange() {
      if (this.cardDetails.pointsCategories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.cardDetails.pointsCategories,
            "single"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }

        if (
          (await this.hasCategoryUniqueNamesGroup(
            this.cardDetails.pointsCategories,
            "group"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories Group field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }

        await this.validatePoints(
          this.cardDetails.pointsCategories,
          "pointCategories"
        );
        await this.validateGroupPoints(
          this.cardDetails.pointsCategories,
          "pointCategories"
        );
        let { pointCategories } = this.errors;
        if (pointCategories.success) {
          return false;
        }
        //console.log(this.cardDetails.pointsCategories);
        //return true;
      }
      if (this.cardDetails.targeted_offers.length > 0) {
        if ((await this.validateMainTargetedOffer()) != true) {
          this.errors.targetedOffers.msg =
            "Targeted Offers field cannot be empty";
          this.errors.targetedOffers.success = true;
          return false;
        }
        let temp = 0;
        let index = 0;
        for await (var i of this.cardDetails.targeted_offers) {
          if ((await this.finalTargetedValidation(index)) != true) {
            temp = 1;
            //return false;
          }
          index++;
        }
        if (temp == 1) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },
    async beforePerksTabChange() {
      await this.validatePerks(this.cardDetails.perks, "perks");
      let { perks } = this.errors;
      if (perks.success) {
        this.scrollToTop();
        return false;
      }

      return true;
    },

    removeCategoryItem(index) {
      this.cardDetails.fee_categories.splice(index, 1);
      this.calculateEffectiveFee();
    },
    calculateEffectiveFee() {
      let result = 0;
      for (var i = 0; i < this.cardDetails.fee_categories.length; i++) {
        result += Number(this.cardDetails.fee_categories[i].amount);
      }
      // if(result >= this.cardDetails.annualFee){
      //     this.calculatedFee = 0;
      // } else {
      this.calculatedFee = this.cardDetails.annualFee - result;
      // }
      this.validateAnnualFee(this.cardDetails.annualFee);
    },
    async handleFilter() {
      this.toggleColorList = true;
    },

    addNewRule() {
      this.cardDetails.rules.push({ effectiveDate: "", rule: "" });
    },
    showFilePath(event) {
      let uploadedPictures = Object.keys(this.$refs.uploadAddCard.files);
      if (
        this.cardDetails.photo_array &&
        this.cardDetails.photo_array.length + 1 + uploadedPictures.length > 10
      ) {
        this.errors.photo = {
          msg: "You cannot upload more than 10 images",
          success: true,
        };
        return;
      }
      var input = event.target;
      let Pictures = Object.keys(input.files);
      if (input.files) {
        Pictures.forEach((index, dataP) => {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.previewPicture.push({
              src: e.target.result,
              defaultImage: this.previewPicture.length == 0 ? true : false,
            });
          };
          this.image = input.files[index];
          reader.readAsDataURL(input.files[index]);
        });
      }
      if (
        this.cardDetails.photo_array &&
        this.cardDetails.photo_array.length == 0 &&
        this.cardDetails.photo.name == undefined
      ) {
        uploadedPictures.forEach((index, imges) => {
          if (index == 0) {
            this.cardDetails.photo = this.$refs.uploadAddCard.files[index];
          } else {
            this.cardDetails.photo_array.push(
              this.$refs.uploadAddCard.files[index]
            );
          }
        });
      } else {
        uploadedPictures.forEach((index, imges) => {
          this.cardDetails.photo_array.push(
            this.$refs.uploadAddCard.files[index]
          );
        });
      }
      //this.cardDetails.photo = this.$refs.uploadAddCard.files[0];
      // if(this.$refs.uploadAddCard.files.length>1){
      //   this.cardDetails.photo_array=this.$refs.uploadAddCard.files;
      // }
      if (this.cardDetails.photo) {
        this.photoChangeFlag = true;
        uploadedPictures.forEach((index, uploadedfile) => {
          if (index == 0) {
            this.validateUploadPhoto(this.cardDetails.photo);
          } else {
            this.validateUploadPhoto(this.cardDetails.photo_array[index]);
          }
          let format = this.$refs.uploadAddCard.files[index].type
            .split("/")
            .pop();
          if (
            this.$refs.uploadAddCard.files[index].size / 1048576 >
            this.$maxFileSize
          ) {
            this.errors.photo = {
              msg: "Photo size must be less than " + this.$maxFileSize + " MB",
              success: true,
            };
          } else {
            this.errors.photo = {
              msg: "",
              success: false,
            };
            if (!this.$photoFormats.includes(format)) {
              this.errors.photo = {
                msg: "Please select a valid photo format",
                success: true,
              };
            } else {
              this.errors.photo = {
                msg: "",
                success: false,
              };
            }
          }
        });
      } else {
        this.errors.photo = {
          msg: "Upload Photo is required",
          success: true,
        };
      }
    },
    updateRule(rule) {
      this.cardDetails.newRuleCheck = rule;
    },
    getCardsList() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetIssuerCards, {
            params: {
              issuerId: this.cardDetails.selectedIssuer._id,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.cardsList = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getIssuers() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors, {
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve(
                (this.issuersList = res.data.data),
                (this.filtererdList = res.data.data)
              );
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    async addCard() {
      this.cardDetails.pointsCategories =
        await this.cardDetails.pointsCategories.map((value) => {
          value.percentage =
            Number(value.percentage) > 0 ? Number(value.percentage) : "";
          value.multiplier = Number(value.multiplier);
          if (value.parentCategoryId) {
            delete value.parentCategoryId;
          }
          return value;
        });

      this.cardDetails.pointsCategories.forEach((main) => {
        main.removed_subCategories = [];
        let subcat = this.pointsCategoriesOption.find(
          (var1) => var1._id == main.points_category
        );
        if (subcat && subcat.subCategories) {
          subcat.subCategories.forEach((fin) => {
            let aab = main.subCategories.find(
              (a) => a.category == fin.category
            );
            if (!aab) {
              if (fin.category != main.points_category) {
                main.removed_subCategories.push({ category: fin.category });
              }
            }
          });
        }
      });

      this.cardDetails.pointsCategories.forEach((main) => {
        let subcat = this.pointsCategoriesOption.find(
          (var1) => var1._id == main.points_category
        );
        if (subcat && subcat.subCategories) {
          subcat.subCategories.forEach((fin) => {
            let aab = main.subCategories.findIndex(
              (a) => a.category == fin.category
            );
            if (aab >= 0) {
              main.subCategories.splice(aab, 1);
            }
          });
        }
      });

      this.cardDetails.pointsCategories.forEach((categories) => {
        if (categories.manage_spend_limit == true) {
          if (
            categories.groupCategories &&
            categories.groupCategories.length > 0
          ) {
            categories.groupCategories.forEach((groupCat) => {
              if (groupCat._id) {
                delete groupCat.name;
                delete groupCat.category_in_limit;
              }
            });
          }
        }
      });

      this.cardDetails.rules = await this.cardDetails.rules.filter(function (
        value
      ) {
        value.effectiveDate = value.effectiveDate
          ? value.effectiveDate
          : new Date();
        return value.rule ? value : null;
      });
      this.validateRules(
        this.cardDetails.rules.length,
        this.cardDetails.newRuleCheck
      );

      if (!this.errors.rules.success) {
        this.cardDetails.fee_categories =
          await this.cardDetails.fee_categories.map((value) => {
            value = {
              credit_title: value.credit_title ? value.credit_title : "",
              amount: value.amount ? value.amount : 0,
              description: value.description ? value.description : "",
              cutoff_date: value.cutoff_date,
              na_cutoff: value.na_cutoff,
              per_use_amount: value.per_use_amount ? value.per_use_amount : "",
              expiration_date_type: value.expiration_date_type
                ? value.expiration_date_type
                : "",
              custom_dates: value.custom_dates ? value.custom_dates : [],
              expiration_date_addition: value.expiration_date_addition
                ? value.expiration_date_addition
                : "",
              bonus_categories: value.bonus_categories
                ? value.bonus_categories
                : [],
            };
            if (value.na_cutoff) {
              delete value.cutoff_date;
            }
            delete value.na_cutoff;
            return value;
          });

        for (var i = 0; i < this.cardDetails.perks.length; i++) {
          if (this.cardDetails.perks[i].show == false) {
            this.cardDetails.perks.splice(i, 1);
          }
        }
        this.cardDetails.perks = await this.cardDetails.perks.map((value) => {
          if (value.na_estimated_val) {
            delete value.estimated_value;
          }
          if (value.call_to_action != "track_usage") {
            delete value.track_usage;
          }
          if (value.call_to_action != "mark_as_enrolled") {
            delete value.mark_as_enrolled;
          }
          if (value.call_to_action != "track_earned_status") {
            delete value.earned_status;
          }
          if (value.call_to_action != "track_earned_tiers") {
            delete value.track_earned_tiers;
          }
          delete value.show;
          return value;
        });

        if (
          this.cardDetails.photo_array &&
          this.cardDetails.photo_array.length > 0 &&
          this.previewPicture &&
          this.previewPicture.length > 0
        ) {
          this.previewPicture.forEach((pictureD, index) => {
            if (pictureD.defaultImage == true && index > 0) {
              let temp = this.cardDetails.photo_array[index - 1];
              this.cardDetails.photo_array.splice(index - 1, 1);
              this.cardDetails.photo_array.push(this.cardDetails.photo);
              this.cardDetails.photo = temp;
            }
          });
        }
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        var data = new FormData();
        data.append("issuer", this.cardDetails.selectedIssuer._id);
        data.append("name", this.cardDetails.cardName);
        data.append("card_type", this.cardDetails.cardType);
        data.append(
          "product_change",
          this.cardDetails.productChange ? this.cardDetails.productChange : ""
        );
        data.append(
          "upgrade_card",
          this.cardDetails.upgradeCard ? this.cardDetails.upgradeCard : ""
        );
        data.append(
          "downgrade_card",
          this.cardDetails.downgradeCard ? this.cardDetails.downgradeCard : ""
        );
        data.append("photo", this.cardDetails.photo);
        if (
          this.cardDetails.photo_array &&
          this.cardDetails.photo_array.length > 0
        ) {
          this.cardDetails.photo_array.forEach((photoData) => {
            data.append("photo", photoData);
          });
        }
        data.append("annual_fee", Number(this.cardDetails.annualFee));
        data.append("effective_fee", Number(this.calculatedFee));
        data.append(
          "fee_categories",
          JSON.stringify(this.cardDetails.fee_categories)
        );
        // data.append('effective_fee_description',this.cardDetails.effectiveDescription);
        // data.append('international_transaction',this.cardDetails.transactionFee);
        if (this.cardDetails.international_transaction_status != "NA") {
          let itval =
            this.cardDetails.international_transaction_status == "yes"
              ? true
              : false;
          data.append("international_transaction", itval);
        }
        data.append("five_twenty_four", this.cardDetails.five_twenty_four);
        data.append(
          "points_categories",
          JSON.stringify(this.cardDetails.pointsCategories)
        );
        data.append(
          "targeted_offers",
          JSON.stringify(this.cardDetails.targeted_offers)
        );
        data.append(
          "points_description",
          this.cardDetails.pointsDescription
            ? this.cardDetails.pointsDescription
            : ""
        );
        // console.log(
        //   "this.dynamic_bonus_categoires",
        //   this.dynamic_bonus_categoires,
        //   "this.dynamic_bonus_categoires"
        // );
        data.append(
          "dynamic_bonus_categoires",
          JSON.stringify(this.dynamic_bonus_categoires)
        );

        data.append(
          "active_rules_check",
          this.cardDetails.newRuleCheck == "Yes" &&
            this.cardDetails.rules.length > 0
            ? true
            : false
        );
        data.append(
          "activeRules",
          this.cardDetails.newRuleCheck == "Yes"
            ? JSON.stringify(this.cardDetails.rules)
            : JSON.stringify([])
        );

        data.append("perks", JSON.stringify(this.cardDetails.perks));

        return new Promise(() => {
          this.$axios
            .post(this.$ApiKeys.BASE_URL + this.$EndPoints.AddCard, data, {
              headers: {
                Authorization: this.$localStorage.get("token"),
                "Content-Type": "multipart/form-data",
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.$router.push({
                  name: "view-cards",
                  params: { add: true },
                });
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.data.errors && e.response.data.errors.name) {
                this.$refs.wiz.changeTab(3, 0);
                this.errors.cardName = {
                  msg: e.response.data.errors.name,
                  success: true,
                };
              } else {
                this.errors.cardName = {
                  msg: "",
                  success: false,
                };
              }
              if (e.response.data.errors.points_category) {
                this.$refs.wiz.changeTab(3, 2);
                this.errors.pointCategories = {
                  msg: e.response.data.errors.points_category,
                  success: true,
                };
              } else {
                this.errors.pointCategories = {
                  msg: "",
                  success: false,
                };
                if (e.response.data.errors.duplicatePointCategories) {
                  this.$refs.wiz.changeTab(3, 2);
                  this.errors.pointCategories = {
                    msg: e.response.data.errors.duplicatePointCategories,
                    success: true,
                  };
                } else {
                  this.errors.pointCategories = {
                    msg: "",
                    success: false,
                  };
                  if (e.response.data.errors.percentage) {
                    this.$refs.wiz.changeTab(3, 2);
                    this.errors.pointCategories = {
                      msg: e.response.data.errors.percentage,
                      success: true,
                    };
                  }
                  if (e.response.data.errors.perks) {
                    this.$refs.wiz.changeTab(3, 3);
                    let errMessage = "Something went wrong!";

                    if (e.response.data.errors.perks.category) {
                      errMessage = e.response.data.errors.perks.category;
                    }
                    if (e.response.data.errors.perks.estimated_value) {
                      errMessage = e.response.data.errors.perks.estimated_value;
                    }
                    if (e.response.data.errors.perks.key_date) {
                      errMessage = e.response.data.errors.perks.key_date;
                    }
                    if (e.response.data.errors.perks.date_type) {
                      errMessage = e.response.data.errors.perks.date_type;
                    }
                    if (e.response.data.errors.perks.custom_dates) {
                      errMessage = e.response.data.errors.perks.custom_dates;
                    }
                    if (e.response.data.errors.perks.weeks) {
                      errMessage = e.response.data.errors.perks.weeks;
                    }
                    if (e.response.data.errors.perks.months) {
                      errMessage = e.response.data.errors.perks.months;
                    }
                    if (e.response.data.errors.perks.years) {
                      errMessage = e.response.data.errors.perks.years;
                    }
                    if (e.response.data.errors.perks.duplicatePerks) {
                      errMessage = e.response.data.errors.perks.duplicatePerks;
                    }

                    this.errors.perks = {
                      msg: errMessage,
                      success: true,
                    };
                  } else {
                    this.errors.pointCategories = {
                      msg: "",
                      success: false,
                    };
                    if (e.response.data.errors.multiplier) {
                      this.$refs.wiz.changeTab(3, 2);
                      this.errors.pointCategories = {
                        msg: e.response.data.errors.multiplier,
                        success: true,
                      };
                    } else {
                      this.errors.pointCategories = {
                        msg: "",
                        success: false,
                      };
                    }
                  }
                }
              }
              if (e.response.data.errors.duplicateRules) {
                this.errors.rules = {
                  msg: e.response.data.errors.duplicateRules,
                  success: true,
                };
              } else {
                this.errors.rules = {
                  msg: "",
                  success: false,
                };
              }
              if (e.response.data.errors.duplicateCategories) {
                this.$refs.wiz.changeTab(3, 1);
                this.errors.feeCategory = {
                  msg: e.response.data.errors.duplicateCategories,
                  success: true,
                };
              } else {
                this.errors.feeCategory = {
                  msg: "",
                  success: false,
                };
                if (e.response.data.errors.amount) {
                  this.$refs.wiz.changeTab(3, 1);
                  this.errors.feeCategory = {
                    msg: e.response.data.errors.amount,
                    success: true,
                  };
                } else {
                  this.errors.feeCategory = {
                    msg: "",
                    success: false,
                  };
                }
              }
              if (
                !e.response.data.errors &&
                !e.response.data.errors.perks &&
                !e.response.data.errors.name &&
                !e.response.data.errors.points_category &&
                !e.response.data.errors.duplicateRules &&
                !e.response.data.errors.duplicateCategories &&
                !e.response.data.errors.amount
              ) {
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
              }
            });
        });
      }
    },
    getRules() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetRules, {
            params: {
              issuerId: this.cardDetails.selectedIssuer._id,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve(
                (this.rulesList = res.data.data),
                this.calculateRulesWidth()
              );
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getCategories() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetCategories, {
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              resolve((this.pointsCategoriesOption = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            // console.log("Error in getCategories: ",e);
          });
      });
    },
    removeSubCategory(index) {
      var a = this.SubCategorypoints.subcategory.splice(index, 1);
      if (a) {
        this.removedSubcategories.push(a);
      }
      this.validateSubCategory();
    },
    handleSelect(index) {
      this.validateSubCategory();
    },
    ManageSubcategory(index, inp2) {
      if (this.cardDetails.pointsCategories[index].points_category) {
        if (
          this.cardDetails.pointsCategories[index].subCategories.length > 0 &&
          this.cardDetails.pointsCategories[index].subCategories[0].category !=
            ""
        ) {
          this.SubCategorypoints.category =
            this.cardDetails.pointsCategories[index].points_category;
          let temp1 = this.pointsCategoriesOption.find(
            (a) =>
              a._id == this.cardDetails.pointsCategories[index].points_category
          );
          if (temp1) {
            this.SubCategorypoints.name = temp1.name;
            this.SubCategorypoints.order = temp1.order;
          }
          if (inp2 == "show") {
            this.SubCategorypoints.show = true;
          }
          if (
            this.cardDetails.pointsCategories[index].points_category !=
            this.cardDetails.pointsCategories[index].parentCategoryId
          ) {
            this.SubCategorypoints.subcategory = [];
            this.SubCategorypoints.parentCategoryId =
              this.SubCategorypoints.category;
          } else {
            this.SubCategorypoints.subcategory =
              this.cardDetails.pointsCategories[index].subCategories;
            this.SubCategorypoints.parentCategoryId =
              this.SubCategorypoints.category;
          }
        } else {
          this.SubCategorypoints.category =
            this.cardDetails.pointsCategories[index].points_category;
          let temp1 = this.pointsCategoriesOption.find(
            (a) =>
              a._id == this.cardDetails.pointsCategories[index].points_category
          );
          if (temp1) {
            this.SubCategorypoints.name = temp1.name;
            this.SubCategorypoints.order = temp1.order;
            this.SubCategorypoints.parentCategoryId = temp1._id;
          }
          if (inp2 == "show") {
            this.SubCategorypoints.show = true;
          }
          this.SubCategorypoints.subcategory = [];
          if (!this.cardDetails.pointsCategories[index].useredit) {
            let tempcat = this.pointsCategoriesOption.find(
              (a) =>
                a._id ==
                this.cardDetails.pointsCategories[index].points_category
            ).subCategories;
            if (tempcat) {
              //   if (this.cardDetails.pointsCategories[index].subCategories.length > 0) {
              //     this.cardDetails.pointsCategories[index].subCategories.pop();
              //   }
              tempcat.forEach((cat) => {
                let aab = this.cardDetails.pointsCategories[
                  index
                ].removed_subCategories.find((a) => a.category == cat.category);
                if (!aab) {
                  this.SubCategorypoints.subcategory.push({
                    category: cat.category.replace(/\s+/g, " "),
                    order: cat.order,
                  });
                }
              });

              this.cardDetails.pointsCategories[index].subCategories =
                this.SubCategorypoints.subcategory;
              this.cardDetails.pointsCategories[index].parentCategoryId =
                this.SubCategorypoints.parentCategoryId;
            }
          }
        }
      }
    },
    async addNewSubCategory() {
      if (this.validateSubCategory() == true) {
        await this.SubCategorypoints.subcategory.push({
          category: "",
          name: "",
          order: "",
          useredit: false,
        });
        this.SubCategorypoints.subcategory =
          await this.SubCategorypoints.subcategory.map((value, index) => {
            return {
              category: value.category,
              order: index + 1,
              useredit: value.useredit,
            };
          });
      }
    },
    async hasUniqueNames(inp) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        if (tmpArr.indexOf(inp[i].category) < 0) {
          tmpArr.push(inp[i].category);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      return true;
    },
    async hasTargetedOfferCategoryUniqueNames(inp, categoryType) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        var tempArrGroup = [];
        if (inp[i].category_type == "single") {
          if (inp[i].categories && inp[i].categories.length > 0) {
            for (var j = 0; j < inp[i].categories.length; j++) {
              if (tmpArr.indexOf(inp[i].categories[j].points_category) < 0) {
                tmpArr.push(inp[i].categories[j].points_category);
              } else {
                // this.error.duplicateIndices.push(i);
                return false;
              }
            }
          }
        }
        if (inp[i].category_type == "group") {
          if (inp[i].categories && inp[i].categories.length > 0) {
            for (var j = 0; j < inp[i].categories.length; j++) {
              if (
                tempArrGroup.indexOf(inp[i].categories[j].points_category) < 0
              ) {
                tempArrGroup.push(inp[i].categories[j].points_category);
              } else {
                // this.error.duplicateIndices.push(i);
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    async hasCategoryUniqueNames(inp, categoryType) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        if (inp[i].type == categoryType) {
          if (tmpArr.indexOf(inp[i].points_category) < 0) {
            tmpArr.push(inp[i].points_category);
          } else {
            // this.error.duplicateIndices.push(i);
            return false;
          }
        }
      }
      return true;
    },
    async hasCategoryUniqueNamesGroup(inp, categoryType) {
      for (var i = 0; i < inp.length; i++) {
        var tmpArr = [];
        if (inp[i].type == categoryType) {
          for (var j = 0; j < inp[i].groupCategories.length; j++) {
            tmpArr.push(inp[i].points_category);
            if (tmpArr.indexOf(inp[i].groupCategories[j].points_category) < 0) {
              tmpArr.push(inp[i].groupCategories[j].points_category);
            } else {
              // this.error.duplicateIndices.push(i);
              return false;
            }
          }
        }
      }
      return true;
    },
    async updateCardSubCategories() {
      if (this.validateSubCategory() != true) {
        return;
      } else if (
        (await this.hasUniqueNames(this.SubCategorypoints.subcategory)) != true
      ) {
        this.errors.subCategory.msg = "SubCategories field must be unique";
        this.errors.subCategory.success = true;
        return;
      } else {
        if (this.errors.subCategory.success == true) {
          this.errors.subCategory.msg = "";
          this.errors.subCategory.success = false;
        }
        if (this.removedSubcategories.length > 0) {
          this.SubCategorypoints.useredit = true;
          this.removedSubcategories = [];
        }
        let tempindex = this.cardDetails.pointsCategories.findIndex(
          (a) => a.points_category == this.SubCategorypoints.category
        );
        if (tempindex >= 0) {
          this.cardDetails.pointsCategories[tempindex].subCategories =
            this.SubCategorypoints.subcategory;
          this.cardDetails.pointsCategories[tempindex].parentCategoryId =
            this.SubCategorypoints.parentCategoryId;
          this.cardDetails.pointsCategories[tempindex].useredit = true;
        }
        this.SubCategorypoints.show = false;
      }
    },
    validateSubCategory() {
      if (this.SubCategorypoints.subcategory.length == 0) {
        this.errors.subCategory.success = false;
        this.errors.subCategory.msg = "";
        return true;
      }
      this.SubCategorypoints.subcategory.forEach((aa) => {
        if (aa.category.trim() == "" || aa.category.length <= 0) {
          this.errors.subCategory.msg = "Please fill out the SubCategory field";
          this.errors.subCategory.success = true;
          return false;
        } else {
          this.errors.subCategory.success = false;
          this.errors.subCategory.msg = "";
        }
      });
      if (this.errors.subCategory.success == true) {
        return false;
      } else {
        return true;
      }
    },
    BacktoMainCategories() {
      if (this.removedSubcategories.length > 0) {
        this.removedSubcategories.forEach((aa) => {
          if (aa && aa[0]) {
            this.SubCategorypoints.subcategory.splice(aa[0].order - 1, 0, {
              category: aa[0].category,
              order: aa[0].order,
            });
          }
        });
        this.removedSubcategories = [];
      }
      //  if (this.validateSubCategory() == true) {
      this.SubCategorypoints.show = false;
      this.cardDetails.pointsCategories.forEach((aa) => {
        let tempindex1 = aa.subCategories.findIndex((a) => a.category == "");
        if (tempindex1 >= 0) {
          aa.subCategories.splice(tempindex1, 1);
        }
      });
      //  }
    },
    categorychangeHandler(inp) {
      if (
        this.cardDetails.pointsCategories[inp].subCategories &&
        this.cardDetails.pointsCategories[inp].subCategories.length > 0
      ) {
        this.cardDetails.pointsCategories[inp].subCategories = [];
      }
      this.ManageSubcategory(inp, "notshow");
      //this.updateAlllimitCategories();
    },
  },
  created() {
    if (this.$route.params.issuerInfo) {
      this.cardDetails.selectedIssuer = {
        name: this.$route.params.issuerInfo.name,
        _id: this.$route.params.issuerInfo._id,
      };
      this.getCardsList();
    }
    this.getIssuers();
    this.getRules();
    this.getCategories();
    EventBus.$emit("resetToggleGroup", true);
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  components: {
    FormWizard,
    TabContent,
    UploadCloudIcon,
    PlusSquareIcon,
    MinusSquareIcon,
    Datepicker,
    Editor,
    Index,
    draggable,
    MenuIcon,
    VueLoadImage,
    modal,
    pointCategorymodal,
  },
  mixins: [clickaway],
};
</script>

<style>
@import "../../../../assets/css/tinymce.css";
@import "./style.css";
@import "../../../../assets/css/add-edit-approve-card.css";
</style>

















/* 


*/